import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// console.log("dashboard");

import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import {
  Stack,
  Chip,
  Avatar,
  Select,
  MenuItem,
  Tooltip,
  Dialog,
  useMediaQuery,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Badge,
} from "@mui/material";
import axios from "axios";
import "../../css/Dashboard/dashboard.css";
import { Route, Routes, useNavigate, Navigate, useLocation } from "react-router-dom";
import { ProductList } from "../Modules/Product List/Pages/ProductList";
import { logOutUser } from "../../Js/generalFunctions";
import { useDispatch, useSelector } from "react-redux";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import { Settings } from "../Modules/Settings/Settings";
import cash from "../../Assets/Images/cash-icon.png";
import card from "../../Assets/Images/master-card-icon.png";
import UPI from "../../Assets/Images/upi-icon.png";
import { Department } from "../Modules/Staff/HRM/Department";
import { Designation } from "../Modules/Staff/HRM/Designation";
import { AddEmployee } from "../Modules/Staff/HRM/AddEmployee/AddEmployee";
import { ManageEmployee } from "../Modules/Staff/HRM/ManageEmployee/ManageEmployee";
import { ViewEmployee } from "../Modules/Staff/HRM/ManageEmployee/ViewEmployee";
import { AddDocument } from "../Modules/Staff/HRM/AddDocument";
import HRMDashboard from "../Modules/Staff/HRM/HRMDashboard";

import { StockReport } from "../Modules/Report/StockReport/StockReport";
import { StockAdjustmentReport } from "../Modules/Report/StockAdjustmentReport/StockAdjustmentReport";
import { ExpenseReport } from "../Modules/Report/ExpenseReport/ExpenseReport";
import { StockSummaryReport } from "../Modules/Report/StockSummaryReport/StockSummaryReport";

import { useEffect } from "react";
import { StaffExpense } from "../Modules/Expense/StaffExpense";
import { OutletExpense } from "../Modules/Expense/OutletExpense";
import { PettyCashReceipt } from "../Modules/Expense/PettyCashReceipt";
import { AddExpenseType } from "../Modules/Expense/AddExpenseType";
import { useState, useRef } from "react";
import { GenerateQrOrBarcode } from "../Modules/GenerateQrOrBarcode/GenerateQrOrBarcode";
import {
  startManualShiftAPICall,
  endManualShiftAPICall,
  addShiftDenominationAPICall,
} from "../../API/Settings/Shift/manualShiftAPI";
import {
  getCurrentTime,
  today,
} from "../../Js/Date";
import ErrorSnackbar from "../Single Components/SnackBars/ErrorSnackbar";

import {
  verifyPasswordForShiftAPICall,
} from "../../API/Login/VerifyPasswordAPI";
import { getShiftStatusAPICAll } from "../../API/Settings/Shift/viewShiftAPI";
import { StaffDashboard } from "../Modules/Staff/DashBoard/StaffDashboard";
import { StaffAttendance } from "../Modules/Staff/Attendance/StaffAttendance";
import { StaffLeaveApplication } from "../Modules/Staff/Leave/StaffLeaveApplication";
import { StaffHoliday } from "../Modules/Staff/Leave/StaffHoliday";
import { StaffAddLeaveType } from "../Modules/Staff/Leave/StaffAddLeaveType";
import { StaffPayrollEmpSalary } from "../Modules/Staff/Payroll/StaffPayrollEmpSalary";
import { StaffPayrollAddPayroll } from "../Modules/Staff/Payroll/StaffPayrollAddPayroll";
import { StaffPayrollItem } from "../Modules/Staff/Payroll/StaffPayrollItem";
import { EmpDashboardTotalCommission } from "../Modules/Staff/HRM/ManageEmployee/Tabs/EmpDashboardTotalCommission";
import { EmployeeTasks } from "../Modules/Staff/HRM/ManageEmployee/Tabs/EmployeeTasks";
import { StaffAddNewLoan } from "../Modules/Staff/Loan/StaffAddNewLoan";
import { StaffLoanReport } from "../Modules/Staff/Loan/StaffLoanReport";
import { StaffLoanApprovals } from "../Modules/Staff/Loan/StaffLoanApprovals";
import { DocumentPrintView } from "../Modules/Staff/HRM/DocumentPrintView";
import { StaffPaySlip } from "../Modules/Staff/Payroll/StaffPaySlip";
import { DeviceSettings } from "../Modules/Settings/Device Settings/DeviceSettings";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import lottie from 'lottie-web';
import newMessageNotification from '../../lottie/NewMassagenotification.json';

// Employee Transition & Performance Management System (Added Nov 2024)
import EmployeeTransitionList from "../Modules/HR/EmployeeTransition/EmployeeTransitionList";
import TransitionCreateForm from "../Modules/HR/EmployeeTransition/TransitionCreateForm";
import PerformanceReviewForm from "../Modules/HR/Performance/PerformanceReviewForm";
import PerformanceReviewList from "../Modules/HR/Performance/PerformanceReviewList";
import KPIManagement from "../Modules/HR/Performance/KPIManagement";
import PerformanceDashboard from "../Modules/HR/Performance/PerformanceDashboard";
import PIPManagement from "../Modules/HR/Performance/PIPManagement";
import PIPCreateForm from "../Modules/HR/Performance/PIPCreateForm";
import GoalManagement from "../Modules/HR/Performance/GoalManagement";
import GoalForm from "../Modules/HR/Performance/GoalForm";
import Feedback360Form from "../Modules/HR/Performance/Feedback360Form";
import AssetList from "../Modules/HR/AssetManagement/AssetList";
import AssetForm from "../Modules/HR/AssetManagement/AssetForm";
import AssetDetailsView from "../Modules/HR/AssetManagement/AssetDetailsView";
import BulkAssetAssignment from "../Modules/HR/AssetManagement/BulkAssetAssignment";
import AssetReports from "../Modules/HR/AssetManagement/AssetReports";
import NotificationCenter from "../Modules/HR/Notifications/NotificationCenter";
import NotificationPreferences from "../Modules/HR/Notifications/NotificationPreferences";
import PushNotificationSetup from "../Modules/HR/Notifications/PushNotificationSetup";
import NotificationSettings from "../Modules/HR/Notifications/NotificationSettings";
import AuditLogs from "../Modules/HR/Notifications/AuditLogs";
import RBACManagement from "../Modules/System/RBACManagement";
import RBACDiagnostics from "../Modules/System/RBACDiagnostics";
import CRMDashboard from "../Modules/CRM/CRMDashboard"; // Added for CRM Module
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import SellerEcommerceDashboard from "../Modules/Ecommerce/SellerEcommerceDashboard";
import EcommerceNotificationPanel from "../Modules/Ecommerce/EcommerceNotificationPanel";
import CampaignManagement from "../Modules/CRM/CampaignManagement"; // AI-Powered Campaigns

import { Journal } from "../Modules/Accounts/Accounting/Journal";
import { JournalEntries } from "../Modules/Accounts/Accounting/JournalEntries";
import { ReccurringPosting } from "../Modules/Accounts/Accounting/ReccurringPosting";
import { ChartOfAccounts } from "../Modules/Accounts/Accounting/ChartOfAccounts";

import { JournalEntriesForm } from "../Modules/Accounts/Accounting/JournalEntriesForm";

import { CreateJournal } from "../Modules/Accounts/Accounting/CreateJournal";
import { Configuration } from "../Modules/Accounts/Configuration/Configuration";
import { CreateChartOfAccount } from "../Modules/Accounts/Accounting/CreateChartofAccount";
import { UnitOfMeasurment } from "../Modules/Purchase Manager/Pages/UnitOfMeasurment/UnitOfMeasurment";
import { NewUOM } from "../Modules/Purchase Manager/Pages/UnitOfMeasurment/NewUOM";
import { ConfigurationPurchase } from "../Modules/Purchase Manager/Pages/Configuration/ConfigurationPurchase";

import { CreateVendorBills1 } from "../Modules/Accounts/Vendor/pages/CreateVendorBills1";
import { VendorPayments } from "../Modules/Accounts/Vendor/pages/VendorPayments";
import { DebitNotes } from "../Modules/Accounts/Vendor/pages/DebitNotes";
import { Vendors } from "../Modules/Accounts/Vendor/pages/Vendors";

import { CreateVendorPayments } from "../Modules/Accounts/Vendor/pages/CreateVendorPayments";
import { CreateVendors } from "../Modules/Accounts/Vendor/pages/CreateVendors";

import { WareHouse } from "../Modules/Inventory/Configuration/WareHouse";
import { InventoryLocation } from "../Modules/Inventory/Configuration/InventoryLocation";
import { CreateWareHouse } from "../Modules/Inventory/Configuration/CreateWareHouse";
import { CreateInvLocation } from "../Modules/Inventory/Configuration/CreateInvLocation";

import { InternalTransfer } from "../Modules/Inventory/Operations/InternalTransfer/InternalTransfer";
import { BranchTransfer } from "../Modules/Inventory/Operations/BranchTransfer/BranchTransfer";

import { InventoryAdjustment } from "../Modules/Inventory/Operations/InventoryAdjustment/InventoryAdjustment";
import { LandedCost } from "../Modules/Inventory/Operations/LandedCost/LandedCost";
import { PhysicalClosingEntry } from "../Modules/Inventory/Operations/PhysicalClosing/PhysicalClosingEntry";

import { StockMoves } from "../Modules/Inventory/Operations/Stock Moves/StockMoves";
import { CreateInternalTransfer } from "../Modules/Inventory/Operations/InternalTransfer/CreateInternalTransfer";
import { CreateBranchTransfer } from "../Modules/Inventory/Operations/BranchTransfer/CreateBranchTransfer";
import { RequestForQuatation } from "../Modules/Purchase Manager/Pages/RequestForQuatation";
import { NewPurchaseOrder } from "../Modules/Purchase Manager/Pages/NewPurchaseOrder";
import { NewGoodsReceivedNotes1 } from "../Modules/Purchase Manager/Pages/NewGoodsReceivedNotes1";

import GoodsReceivedNotesSingleView from "../Modules/Purchase Manager/Pages/GRNUpdated/GoodsReceivedNotesSingleView";
import { VendorListPurchaseManage } from "../Modules/Purchase Manager/Pages/Vendor/VendorListPurchaseManage";
import { SalesOrder } from "../Modules/SalesNew/SalesOrders/SalesOrder/SalesOrder";
import { SalesQuotation } from "../Modules/SalesNew/SalesOrders/SalesQuotation/SalesQuotation";
import { CreateSalesQuotation } from "../Modules/SalesNew/SalesOrders/SalesQuotation/CreateSalesQuotation";
import { CreateSalesOrder } from "../Modules/SalesNew/SalesOrders/SalesOrder/CreateSalesOrder";
import { DeliveryNote } from "../Modules/SalesNew/SalesOrders/DeliveryNote/DeliveryNote";
import { CreateDeliiveryNote } from "../Modules/SalesNew/SalesOrders/DeliveryNote/CreateDeliiveryNote";
import { CustomerInvoice } from "../Modules/Accounts/Customers/CustomerInvoice/CustomerInvoice";
import { CustomerPayments } from "../Modules/Accounts/Customers/Payments/CustomerPayments";
import { CustomerCreditNotes } from "../Modules/Accounts/Customers/CreditNotes/CustomerCreditNotes";
import { Customers } from "../Modules/Accounts/Customers/Customers/Customers";
import { CreateCustomerInvoice } from "../Modules/Accounts/Customers/CustomerInvoice/CreateCustomerInvoice";
import { CreateCustomerPayment } from "../Modules/Accounts/Customers/Payments/CreateCustomerPayment";
import { CreateCustomerCreditNotes } from "../Modules/Accounts/Customers/CreditNotes/CreateCustomerCreditNotes";
import { CreateDebitNote } from "../Modules/Accounts/Vendor/pages/CreateDebitNote";
import { CreateCustomer } from "../Modules/Accounts/Customers/Customers/CreateCustomer";
import { SettingsProductVariant } from "../Modules/Inventory/Configuration/SettingsProductVariant";
import { Attribute } from "../Modules/Inventory/Configuration/Attribute/Attribute";
import { CreateAttribute } from "../Modules/Inventory/Configuration/Attribute/CreateAttribute";
import { POSCategory } from "../Modules/Inventory/Configuration/POSCategory/POSCategory";
import { CreatePOSCategory } from "../Modules/Inventory/Configuration/POSCategory/CreatePOSCategory";
import { Category } from "../Modules/Inventory/Configuration/Category/Category";
import { CreateCategory } from "../Modules/Inventory/Configuration/Category/CreateCategory";
import { CreateInventoryAdjustment } from "../Modules/Inventory/Operations/InventoryAdjustment/CreateInventoryAdjustment";
import { SalesWSO } from "../Modules/Accounts/Customers/SalesWSO/SalesWSO";
import { CreateSalesWSO } from "../Modules/Accounts/Customers/SalesWSO/CreateSalesWSO";
import { BranchReceipt } from "../Modules/Inventory/Operations/BranchReceipt/BranchReceipt";
import { CreateBranchReceipt } from "../Modules/Inventory/Operations/BranchReceipt/CreateBranchReceipt";
import { ProductListUpdated } from "../Modules/Inventory/Products/ProductListUpdated/ProductListUpdated";
import { CreateProductList } from "../Modules/Inventory/Products/ProductListUpdated/CreateProductList";
import { ProductMasterUpdated } from "../Modules/Inventory/Products/ProductMasterUpdated/ProductMasterUpdated";
import { CreateProductMaster } from "../Modules/Inventory/Products/ProductMasterUpdated/CreateProductMaster";
import { CreateRequestForQuotation1 } from "../Modules/Purchase Manager/Pages/CreateRequestForQuotation1";
import { CreateNewPurchaseOrder1 } from "../Modules/Purchase Manager/Pages/CreateNewPurchaseOrder1";
import { GrnListing1 } from "../Modules/Purchase Manager/Pages/GRNUpdated/GrnListing1";

import { VendorBills1 } from "../Modules/Accounts/Vendor/pages/VendorBills1";
import { PurchaseWOPO1 } from "../Modules/Accounts/Vendor/purchaseWPO/PurchaseWOPO1";

import { BillingNew } from "../Modules/Sales/Billing/BillingNew";
import { CreatePurchaseWOPO1 } from "../Modules/Accounts/Vendor/purchaseWPO/CreatePurchaseWOPO1";

import CreateLandedCost from "../Modules/Inventory/Operations/LandedCost/CreateLandedCost";

import { RequestForQuatationSingleView } from "../Modules/Purchase Manager/Pages/RequestForQuatationSingleView";

import { PosSettings } from "../Modules/PointOfSale/Configuration/Settings/PosSettings";
import { BranchSettings } from "../Modules/PointOfSale/Configuration/BranchSettings/BranchSettings";
import { BranchSettingsForm } from "../Modules/PointOfSale/Configuration/BranchSettings/BranchSettingsForm";
import { SalesQuatationSingleVieww } from "../Modules/SalesNew/SalesOrders/SalesQuotation/SalesQuatationSingleVieww";
import { DeliverNoteSingleView } from "../Modules/SalesNew/SalesOrders/DeliveryNote/DeliverNoteSingleView";
import { SalesCustomers } from "../Modules/SalesNew/SalesOrders/SalesCustomers/SalesCustomers";

import { viewPosSettingsAPICall } from "../Modules/PointOfSale/Configuration/Settings/posSettingsAPI";
import { getAllActiveEmployeesAPICall, getEmployeesByBranch } from "../../API/Staff/HRM/employeeAPI";

import { SalesWSOsingleView } from "../Modules/Accounts/Customers/SalesWSO/SalesWSOsingleView";
import { DebitNoteSingleView } from "../Modules/Accounts/Vendor/pages/DebitNoteSingleView";
import { VendorBillSingleView } from "../Modules/Accounts/Vendor/pages/VendorBillSingleView";
import { PurchaseWOPOsingleView } from "../Modules/Accounts/Vendor/purchaseWPO/PurchaseWOPOsingleView";
import CreatePriceList from "../Modules/SalesNew/SalesOrders/priceList/CreatePriceList";
import PriceList from "../Modules/SalesNew/SalesOrders/priceList/PriceList";
import { SalesOrderSingleView } from "../Modules/SalesNew/SalesOrders/SalesOrder/SalesOrderSingleView";
import { PurchaseOrderSingleView } from "../Modules/Purchase Manager/Pages/PurchaseOrderSingleView";
import { CreaditNoteSingleView } from "../Modules/Accounts/Customers/CreditNotes/CreaditNoteSingleView";
import { CustomerInvoiceSingleView } from "../Modules/Accounts/Customers/CustomerInvoice/CustomerInvoiceSingleView";
import PosOrdersSingleView from "../Modules/PointOfSale/General/Order/PosOrdersSingleView";
import {
  viewCashInOrCashOutAPICall,
} from "../../API/Dashboards/mainDashboardAPI";
import SuccessSnackbar from "../Single Components/SnackBars/SuccessSnackbar";

import { TrialBalance } from "../Modules/Accounts/ReportsNew/FinancialReports/TrialBalance";
import html2canvas from 'html2canvas';

import jsPDF from 'jspdf';
import { viewGlConfigAPICall } from "../Modules/Accounts/Configuration/glConfigAPI";
import { viewAllCurrencyUpdated } from "../../API/Settings/Currency/CurrencyAPI";

import { LedgerBalance } from "../Modules/Accounts/ReportsNew/FinancialReports/LedgerBalance";
import { GeneralLedgerNw } from "../Modules/Accounts/ReportsNew/FinancialReports/GeneralLedgerNw";
import { ProfitAndLoss } from "../Modules/Accounts/ReportsNew/FinancialReports/ProfitAndLoss";
import { SalesNewReport } from "../Modules/SalesNew/SalesReport/SalesNewReport";
import { AccountPayable } from "../Modules/Accounts/ReportsNew/PartnerReport/AccountPayable";
import AccountPayableSingleView from "../Modules/Accounts/ReportsNew/PartnerReport/AccountPayableSingleView";
import AccountReceivableAgingReport from "../Modules/Accounts/ReportsNew/PartnerReport/AccountReceivableAgingReport";
import { AccountRecievable } from "../Modules/Accounts/ReportsNew/PartnerReport/AccountRecievable";
import { BankAndCashReport } from "../Modules/Accounts/ReportsNew/General Report/BankAndCashReport";
import BankAndCashReportSingleView from "../Modules/Accounts/ReportsNew/General Report/BankAndCashReportSingleView";
import { AccountRecievableSingleView } from "../Modules/Accounts/ReportsNew/PartnerReport/AccountRecievableSingleView";
import { SalesReportSingleView } from "../Modules/SalesNew/SalesReport/SalesReportSingleView";
import BalanceSheet from "../Modules/Accounts/ReportsNew/FinancialReports/BalanceSheet";
import { StockMove } from "../Modules/Inventory/Reports/StockMove";
import IaReport from "../Modules/Inventory/Reports/IaReport"
import { StockMoveSingleView } from "../Modules/Inventory/Reports/StockMoveSingleView";
import PurchaseReportNew from "../Modules/Purchase Manager/Pages/PurchaseReport.jsx/PurchaseReportNew";
import { PurchaseReportSingleView } from "../Modules/Purchase Manager/Pages/PurchaseReport.jsx/PurchaseReportSingleView";

import { BankReconciliationNew } from "../Modules/Accounts/Reconciliation/BankReconciliationNew";
import { CreateBankReconciliation } from "../Modules/Accounts/Reconciliation/CreateBankReconciliation";

import { PosSalesReport } from "../Modules/Report/POSSalesReport/PosSalesReport";
// import EstablisId from "../Modules/Payroll/Establishment/EstablisId";
import InputOrOutputReport from "../Modules/Accounts/VatReport/inputOrOutputReport/InputOrOutputReport";

import { getAllNewProductList } from "../Modules/Accounts/Vendor/API/vendorBillAPI";
import { vendorListApi } from "../Modules/Accounts/Vendor/API/vendorListAPICall";
import { customerListApi } from "../../API/Customer/customerAPI";

// import OvertimeList from "../Modules/Payroll/Attendance/Overtime/OvertimeList";
import AccountReceivableAgingReportSingleView from "../Modules/Accounts/ReportsNew/PartnerReport/AccountReceivableAgingReportSingleView";
import AccountPayableAgingReport from "../Modules/Accounts/ReportsNew/PartnerReport/AccountPayableAgingReport";
import AccountPayableAgingReportSingleView from "../Modules/Accounts/ReportsNew/PartnerReport/AccountPayableAgingReportSingleView";
// import PayHead from "../Modules/Payroll/configuration/payHead/PayHead";
import { QrcodeScanView } from "../Modules/Sales/Billing/QrcodeScanView";
import { ProductListSingleView } from "../Modules/Product List/Pages/ProductListSingleView";
import AddSeat from "../Modules/FloorManagement/addSeat/AddSeat";
import { get_check_out, switch_to_billing_screen } from "../Modules/Sales/Billing/newBillingSlice";
import KitchenOrderTicket from "../Modules/kitchenOrderTicket/KitchenOrderTicket";
import KotTokenDisplay from "../Modules/KotTokenDisplay/KotTokenDisplay";
import KotTokenDisplay2 from "../Modules/KotTokenDisplay/KotTokenDisplay2";
import SpecialItems from "../Modules/Sales/SpecialItems/SpecialItems";
import CreateSpecialItems from "../Modules/Sales/SpecialItems/CreateSpecialItems";
import {
  setErrorSnack,
  setSnackMsg,
  setSuccessSnack,
} from "../Modules/Sales/Billing/Slice/billingScreenSlice";
import CustomerDisplay from "../Modules/customerDisplay/CustomerDisplay";
import { ConfigurationFood } from "../Modules/FoodManagementCopy/ConfigurationFood";
import RecipeFood from "../Modules/FoodManagementCopy/RecipeFood";
import Aggregator from "../Modules/PointOfSale/Configuration/Aggregator/Aggregator";
import { companyProfileInfoForUser, viewAllBranchesAPICall } from "../../API/Settings/Company Settings/companySettingsAPI";

import PosShift from "../Modules/PointOfSale/General/Shift/PosShift";

import RecipeCostAnalysis from "../Modules/FoodManagementCopy/RecipeCostAnalysis";
import RecipeFoodList from "../Modules/FoodManagementCopy/RecipeFoodList";

import PosReaderPreview from "../Modules/PointOfSale/posReaderPreview/PosReaderPreview";

import PosShiftSingleView from "../Modules/PointOfSale/General/Shift/PosShiftSingleView";
import ManufacturingOrder from "../Modules/FoodManagementCopy/ManufacturingOrder";
import ManufacturingOrderList from "../Modules/FoodManagementCopy/ManufacturingOrderList";
import ManufacturingCostAnalysis from "../Modules/FoodManagementCopy/ManufacturingCostAnalysis";
import PosOrders from "../Modules/PointOfSale/General/Order/PosOrders";
import PosPayment from "../Modules/PointOfSale/General/payment/PosPayment";
import PosWallet from "../Modules/PointOfSale/General/wallet/PosWallet";
import PosShiftReport from "../Modules/PointOfSale/Report/PosShiftReport";
import PosShiftSummaryReport from "../Modules/PointOfSale/Report/PosShiftSummaryReport";
import PosSalesDetails from "../Modules/PointOfSale/Report/PosSalesDetails";

import AccountDashboard from "../Modules/Accounts/Dashboard/AccountDashboard";

import { setBranchDetails, setCurrencyDetails, setEmployeeDetails } from "../../Redux/Dashboard/mainDashBoardSlice";
import { setNeedsSetup } from "../../Redux/Dashboard/mainDashBoardSlice";

import ReceivableDueReport from "../Modules/Accounts/ReportsNew/PartnerReport/ReceivableDueReport";
import ReceivableDueReportSingleView from "../Modules/Accounts/ReportsNew/PartnerReport/ReceivableDueReportSingleView";
import PyableDueReport from "../Modules/Accounts/ReportsNew/PartnerReport/PyableDueReport";
import PayableDueReportSingleView from "../Modules/Accounts/ReportsNew/PartnerReport/PayableDueReportSingleView";
import InvoiceMarginReport from "../Modules/Accounts/ReportsNew/General Report/InvoiceMarginReport";
import InvoiceMarginReportSingleView from "../Modules/Accounts/ReportsNew/General Report/InvoiceMarginReportSingleView";
import ProductMarginReport from "../Modules/Accounts/ReportsNew/General Report/ProductMarginReport";
import ProductMarginReportSingleView from "../Modules/Accounts/ReportsNew/General Report/ProductMarginReportSingleView";

import HomeDashboardNew from "../Modules/HomeDashboard/homeDashboardNew/HomeDashboard";

//payroll
// import Payslip from "../Modules/Payroll/payslip/Payslip";
import Payslip from "../Modules/Payroll/payslip/Payslip";
import CreatePayslip from "../Modules/Payroll/payslip/CreatePayslip";
// import BatchPayslip from "../Modules/Payroll/BatchPayslip/BatchPayslip";
import BatchPayslip from "../Modules/Payroll/BatchPayslip/BatchPayslip";
import CreateBatchPayslip from "../Modules/Payroll/BatchPayslip/CreateBatchPayslip";
// New Payroll Components (Added Oct 30, 2025)
import PayrollDashboard from "../Modules/Payroll/Setup/PayrollDashboard";
import PayrollSetupWizard from "../Modules/Payroll/Setup/PayrollSetupWizard";
import ComputePayslip from "../Modules/Payroll/payslip/ComputePayslip";
import PayslipList from "../Modules/Payroll/payslip/PayslipList";
import ComputeBatchPayslip from "../Modules/Payroll/BatchPayslip/ComputeBatchPayslip";
import SalaryDisbursement from "../Modules/Payroll/SalaryDisbursement/SalaryDisbursement";
import CreateSalaryDisbursement from "../Modules/Payroll/SalaryDisbursement/CreateSalaryDisbursement";
import ContractPayslip from "../Modules/Payroll/Contract/ContractPayslip";
import CreateContractPayslip from "../Modules/Payroll/Contract/CreateContractPayslip";
import SponsorPayslip from "../Modules/Payroll/Sponsor/SponsorPayslip";
import CreateSponsorPayslip from "../Modules/Payroll/Sponsor/CreateSponsorPayslip";
import LoanPayroll from "../Modules/Payroll/Loan/Loan/LoanPayroll";
import CreateLoanPayroll from "../Modules/Payroll/Loan/Loan/CreateLoanPayroll";
import LoanEligibility from "../Modules/Payroll/Loan/Loan eligibility/LoanEligibility";
import CreateLoanEligibility from "../Modules/Payroll/Loan/Loan eligibility/CreateLoanEligibility";
import AttendancePayroll from "../Modules/Payroll/Attendance/attendance/AttendancePayroll";
import AttendanceSettings from "../Modules/Payroll/Attendance/AttendanceSettings";
import EossPayroll from "../Modules/Payroll/Attendance/EOSS/EossPayroll";
import CreateEoss from "../Modules/Payroll/Attendance/EOSS/CreateEoss";
import PayrollLeave from "../Modules/Payroll/Attendance/leave/PayrollLeave";
import CreatePayrollLeave from "../Modules/Payroll/Attendance/leave/CreatePayrollLeave";
import LeaveBalance from "../Modules/Payroll/Attendance/leave/LeaveBalance";
import LeaveType from "../Modules/Payroll/Attendance/leave/LeaveType";
import OvertimePayroll from "../Modules/Payroll/Attendance/overTime/OvertimePayroll";
import CreateOvertimePayroll from "../Modules/Payroll/Attendance/overTime/CreateOvertimePayroll";
import PayrollPayHead from "../Modules/Payroll/configuration/PayHead/PayrollPayHead";
import CreatePayHead from "../Modules/Payroll/configuration/PayHead/CreatePayHead";
import PayOthersPayroll from "../Modules/Payroll/configuration/PayOther/PayOthersPayroll";
import CreatePayOthers from "../Modules/Payroll/configuration/PayOther/CreatePayOthers";
import PayTemplatePayroll from "../Modules/Payroll/configuration/payTemplate/PayTemplatePayroll";
import CreatePaytemplate from "../Modules/Payroll/configuration/payTemplate/CreatePaytemplate";
import PayrollSettings from "../Modules/Payroll/configuration/settings/PayrollSettings";

import VariableAllowance from "../Modules/Payroll/variableAndRecurring/allowance/variableAllowance/VariableAllowance";
import CreateVariableAllowance from "../Modules/Payroll/variableAndRecurring/allowance/variableAllowance/CreateVariableAllowance";
import RecurringAllowance from "../Modules/Payroll/variableAndRecurring/allowance/recurringAllowance/RecurringAllowance";
import CreateRecurringAllowance from "../Modules/Payroll/variableAndRecurring/allowance/recurringAllowance/CreateRecurringAllowance";
import VariableDeduction from "../Modules/Payroll/variableAndRecurring/deduction/variableDeduction/VariableDeduction";
import CreateVariableDeduction from "../Modules/Payroll/variableAndRecurring/deduction/variableDeduction/CreateVariableDeduction";
import RecurringDeduction from "../Modules/Payroll/variableAndRecurring/deduction/reccurringDeduction/ReccurringDeduction";
import CreateRecurringDeduction from "../Modules/Payroll/variableAndRecurring/deduction/reccurringDeduction/CreateRecurringDeduction";


import CustomerReceiptReport from "../Modules/Accounts/ReportsNew/General Report/CustomerReceiptReport";
import CustomerReceiptReportSingleView from "../Modules/Accounts/ReportsNew/General Report/CustomerReceiptReportSingleView";
import SalesReportBySalesPerson from "../Modules/SalesNew/SalesReport/SalesReportBySalesPerson";
import SalesReportBySalesSingleView from "../Modules/SalesNew/SalesReport/SalesReportBySalesSingleView";
import OpeningBalance from "../Modules/Accounts/Accounting/OpeningBalance";
import CreateOpeningBalance from "../Modules/Accounts/Accounting/CreateOpeningBalance";

import PrintDemo from "../Modules/PrintDemo";
import DailyCashCardSummary from "../Modules/PointOfSale/Report/DailyCashCardSummary";
import PosSalesSummery from "../Modules/PointOfSale/Report/PosSalesSummery";
import PosAggregatorReport from "../Modules/PointOfSale/Report/PosAggregatorReport";
import ChequeRegisterReport from "../Modules/Accounts/ReportsNew/General Report/ChequeRegisterReport";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import SideMenuUpdated from "./SideMenuUpdated";
import { viewInventoryConfigSettingsAPICall } from "../Modules/Inventory/Configuration/inventoryConfigurationSettingsAPI";
import { employeeRolesAndPermission } from "../../API/Settings/Roles and permission/rolesAndPermissionAPI";
import { RolesAndPermissionNew } from "../Modules/Settings/RolesAndPermission Settings/RolesAndPermissionNew";
import { AccessDenied } from "./AccessDenied";
import CashInOrOut from "../Single Components/CashInOrOut/CashInOrOut";
import { setCashInOrOutDialog } from "../../Redux/Dashboard/cashInOrOutSlice";

import PosNewShiftReport from "../Modules/PointOfSale/Report/PosNewShiftReport";
import DeliveryScreen from "../Modules/PointOfSale/DeliveryScreen/DeliveryScreen";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { set_shift_report_branch, set_shift_report_shift, set_shift_report_submit } from "../Modules/PointOfSale/Report/ReportSlice";
import ShiftReportTable from "../Modules/PointOfSale/Report/PosShiftReportTables/ShiftReportTable";
import AdvanceSummaryFullPrint from "../Modules/PointOfSale/Report/AdvancedShiftReportPRint/AdvanceSummaryFullPrint";
import AdvanceShiftReportPrintComponent from "../Modules/PointOfSale/Report/AdvancedShiftReportPRint/AdvanceShiftReportPrintComponent";
import { useReactToPrint } from "../Shared/print/useHtml2PdfPrint";
import { printDomAsPdfWithPopup } from "../Shared/print/printUtils";
import ShiftTimerComponent from "../Single Components/ShiftTimerComponent";
import SelfOrderScreen from "../../SelfOrderComponents/SelfOrderScreen";
import PortableScreen from "../Modules/Portable/PortableScreen";
import SyncSessionDataButton from "../Single Components/ActionButtons/SyncSessionDataButton";
import NotificationPopup from "../Single Components/NotificationPopup";
import { SyncStatusIndicator } from '../../offline';
import useRefreshPrevention from '../../offline/useRefreshPrevention';
import TimeSalesReport from "../Modules/TimeSalesReport/TimeSalesReport";
import photo from "../../Assets/Images/b1fac8457e015cf2d2dcf2fbebe8c9f2.jpg"
import { getCheckInDetail, getCheckOutDetail, getCheckOutSubmit, getShiftEndDetail } from "../Modules/Sales/Billing/newBillingAPI";
import store from "../../Redux/store";
import { sendWhatsAppMessageAPI, sendWhatsAppMessageAPIDashboard } from "../Modules/PointOfSale/Configuration/BranchSettings/BranchSettingsAPI";
import PosShiftReportPrint from "../Modules/PointOfSale/Report/PosShiftReportPrint"
import { ListPosCheckinSummaryAPI } from "../Modules/PointOfSale/Report/ReportAPI";
import { errorSnackMsg, successSnackMsg } from "../Custom Hooks/SnackkBarUtilities";
import { GstrReport } from "../Modules/Accounts/ReportsNew/FinancialReports/GstrReport";
import CheckInStatusIndicator from "../Single Components/CheckInStatusIndicator";
import CachedImage from "../../offline/components/CachedImage";
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import PersonIcon from '@mui/icons-material/Person';
import hybridSocket from '../../offline/hybridSocket';
import socketClient from '../../socket/socketClient';


const drawerWidth = 290;



const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: 12,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));


const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

const mdTheme = createTheme();

function ProtectedRoute({ element: Element, isAuthenticated, fallbackPath, ...rest }) {
  // console.log("isAuthenticated",isAuthenticated);
  return isAuthenticated ? (
    <Element {...rest} />
  ) : (
    <Navigate to={fallbackPath} />
  );
}

function DashboardHomeEntry() {
  const permission = JSON.parse(localStorage.getItem("userpermission")) || {};
  const userRole = localStorage.getItem("userRole");

  const canDashboard = Boolean(permission?.dashboard);
  const canBilling = Boolean(permission?.pointOfSales?.billing) || userRole === "admin";

  const reportPerms = permission?.pointOfSales?.report;
  const canTimeSalesReport =
    userRole === "admin" ||
    (reportPerms && typeof reportPerms === "object" && Object.values(reportPerms).some(Boolean));

  if (canDashboard) return <HomeDashboardNew />;
  if (canTimeSalesReport) return <Navigate to="/userdashboard/timeSalesReport/timeSalesReport" replace />;
  if (canBilling) return <Navigate to="/userdashboard/pos/billingnew" replace />;
  return <Navigate to="/userdashboard/403" replace />;
}

function DashboardContent() {
  const isMobile = useMediaQuery('(max-width:500px)');
  
  // Prevent page refresh when offline with pending transactions
  useRefreshPrevention({ enabled: true, showWarning: true });
  
  // advance shift report template ref
  const printRef = useRef(null);
  // shift report template ref
  let paymentsPrint = useRef(null);
  // receipt print ref for html2pdf
  const receiptPrintRef = useRef(null);
  const billingScreen = useSelector(
    (state) => state.newBillingSlice.billingScreen
  );
  const userInfo = useSelector((state) => state.loginResponseSlice.value);
  const userBranchIdWS = userInfo?.branchPk;
  const permission = JSON.parse(localStorage.getItem("userpermission"))
  // console.log(permission);
  const dispatch = useDispatch();
  const needsSetup = useSelector((state) => state.mainDashBoardSlice?.needsSetup);
  //Login Response From Redux
  // pos settings
  const posSettingsList = useSelector(
    (state) => state.posSettingSlice.apiResList
  );
  const { authPassWord, branchConfigurationList } = useSelector((state) => state.newBillingSlice);
  //Active Employee List
  const allActiveEmpList = useSelector(
    (state) => state.allActiveEmployeeSlice.value
  );
  const allBranchesList = useSelector((state) => state.allBranchesSlice.value);
  const companyProfileData = useSelector(
    (state) => state?.companyProfileSlice?.userValue
  );
  const userName = userInfo?.userName;

  const currencyListUpdated = useSelector(
    (state) => state.viewUpdatedCurrency.value
  );
  const { hideHeader } = useSelector(
    (state) => state.kotTokenDisplaySlice
  );
    const checkinSummmary = useSelector(
      (state) => state.posReportshiftSlice.shiftReporCheckinSummary
    );
  const { checkOutPassDetail, checkOutDetail, shiftEndtDetail } = useSelector((state) => state.newBillingSlice)
  // console.log(checkOutPassDetail, "2342");
  // console.log(checkOutDetail);
  // console.log(shiftEndtDetail);
  // console.log(checkOutDetail?.data?.checkOut);
  const [branchName, setBranchName] = useState("...");
  const userRole = useSelector((state) => state.userRoleSlice.value);
  const userLoginMeta = localStorage.getItem("login_meta");
  const selfUser = localStorage.getItem("selfUser");
  const userBranchId = JSON.parse(userLoginMeta)?.branchId;
  const userBranchpk = JSON.parse(userLoginMeta)?.branchPk;
  const employeeId = JSON.parse(userLoginMeta)?.data?._id
  const userShiftStatus = localStorage.getItem("shiftStatus");
  const userShiftId = JSON.parse(userShiftStatus)?.shiftId;
  const userShiftCode = JSON.parse(userShiftStatus)?._id;
  const storeCode = localStorage.getItem("branchId");
  const KOTtemp = localStorage.getItem("templatekot");

  // let cashInOutPrint = useRef()

  // shift button change state
  const [shiftBtnState, setShiftBtnState] = useState(false);
  // shift end password dialog state
  const [shiftEndPasswordDialog, setShiftEndPasswordDialog] = useState(false);

  // snackbar state
  const [errorSnackBar, setErrorSnackBar] = useState(false);
  const [sucessSnackBar, setSuccessSnackBar] = useState(false);
  const [errorMsg, setErrorMsg] = useState("Error!!");
  const notificationLottieRef = useRef(null);
  const notificationLottieInstance = useRef(null);
  const [showUpArrow, setShowUpArrow] = useState(false);
  const [denomination, setDenomination] = useState([]);
  const [timer, setTimer] = useState(0);
  const [verifyPassWord, setVerifyPassword] = useState("");


  const [shiftReoprtOpen, setShiftReportBtn] = useState(false);
  // denomination dialog
  const [denominationDialog, setDenominationDialog] = useState(false);
  const [showCheckOutPopup, setShowCheckOutPopup] = useState(false);
  const [password, setPassword] = useState(false);
  const [description, setDescription] = useState("");
  const [showSecondCheckOutPopup, setShowSecondCheckOutPopup] = useState(false);
  const [showFinalCheckOutPopup, setShowFinalCheckOutPopup] = useState(false);
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const [showReceiptPrintDialog, setShowReceiptPrintDialog] = useState(false);
  const [selectedCheckoutEmployee, setSelectedCheckoutEmployee] = useState(null);

  // Notification Center unread count
  const [unreadNotifications, setUnreadNotifications] = useState(0);

  const [hasEcommerceStore, setHasEcommerceStore] = useState(false);
  const [ecommercePendingCount, setEcommercePendingCount] = useState(0);
  const [ecommerceNotificationOpen, setEcommerceNotificationOpen] = useState(false);

  const increment = useRef(null);
  let date = new Date();


  const [shiftDenominationTable, setShiftDenominationTable] = useState([]);
  const [denominationGrandTotal, setShiftDenominationGrandTotal] = useState("");
  const shiftDenominationBodyInitialState = {
    currency: "Rs",
    amount: "",
    count: "",
    total: "0.00",
    grandTotal: "",
  };

  const [shiftDenominationBody, setShiftDenominationBody] = useState(
    shiftDenominationBodyInitialState
  );

  const [fullScreenEnable, setEnableFullScreen] = useState(false)
  const [billingHeaderCollapsed, setBillingHeaderCollapsed] = useState(false)

  // Initialize Socket.IO connection on mount
  useEffect(() => {
    console.log('🔌 Initializing Socket.IO connection...');
    socketClient.initialize();

    return () => {
      console.log('🔌 Cleaning up Socket.IO connection...');
      socketClient.disconnect();
    };
  }, []);

  // Initialize Lottie animation for notification bell
  useEffect(() => {
    if (notificationLottieRef.current && !notificationLottieInstance.current) {
      notificationLottieInstance.current = lottie.loadAnimation({
        container: notificationLottieRef.current,
        animationData: newMessageNotification,
        renderer: 'svg',
        loop: true,
        autoplay: false,
      });
    }

    return () => {
      if (notificationLottieInstance.current) {
        notificationLottieInstance.current.destroy();
        notificationLottieInstance.current = null;
      }
    };
  }, []);

  // Play / stop Lottie based on unread count
  useEffect(() => {
    if (!notificationLottieInstance.current) return;

    if (unreadNotifications > 0) {
      notificationLottieInstance.current.play();
    } else {
      notificationLottieInstance.current.stop();
    }
  }, [unreadNotifications]);

  // Fetch unread notification count once on mount (initial load).
  // Ongoing updates come from hybrid/socket events.
  useEffect(() => {
    let isMounted = true;

    const fetchUnreadCount = async () => {
      try {
        // Use the same list API as NotificationCenter to ensure consistent unread count
        const res = await axios.post('/api/employee-notification/list', {
          status: 'UNREAD',
          page: 1,
          limit: 1,
        });

        if (isMounted && res?.data?.success) {
          const total = res.data?.pagination?.total ?? 0;
          console.log('🔔 Dashboard: Polling fetched unread count from backend:', total);
          setUnreadNotifications(typeof total === 'number' ? total : 0);
        }
      } catch (error) {
        if (isMounted) {
          // On error, do not spam logs or show UI errors; just keep last value
          // console.error('Failed to fetch unread notifications count:', error);
        }
      }
    };

    fetchUnreadCount();

    return () => {
      isMounted = false;
    };
  }, []);

  // Show Ecommerce header icon only if store is registered (run once)
  useEffect(() => {
    let isMounted = true;

    const loadEcommerceStatus = async () => {
      try {
        const res = await axios.get('/api/ecommerce-store/me');
        console.log('🏪 [ECOMMERCE ICON] API Response:', res?.data);
        const storeData = res?.data?.data;
        const exists = Boolean(res?.data?.success && storeData);
        const isEnabled = Boolean(storeData?.enabled);
        console.log('🏪 [ECOMMERCE ICON] Store exists:', exists, 'Enabled:', isEnabled, 'Will show icon:', exists && isEnabled);
        if (isMounted) {
          setHasEcommerceStore(exists && isEnabled);
        }
      } catch (e) {
        console.error('🏪 [ECOMMERCE ICON] API Error:', e);
        if (isMounted) {
          setHasEcommerceStore(false);
        }
      }
    };

    loadEcommerceStatus();

    return () => {
      isMounted = false;
    };
  }, []);

  // Poll for pending ecommerce orders only when store is active
  useEffect(() => {
    if (!hasEcommerceStore) return;
    let isMounted = true;

    const fetchEcommercePendingCount = async () => {
      try {
        const res = await axios.get('/api/ecommerce-store/me/pending-orders');
        if (res?.data?.success && isMounted) {
          setEcommercePendingCount((res.data.data || []).length);
        }
      } catch (e) {
        // Silent fail
      }
    };

    fetchEcommercePendingCount();

    // Poll for pending orders every 30 seconds
    const pollInterval = setInterval(fetchEcommercePendingCount, 30000);

    return () => {
      isMounted = false;
      clearInterval(pollInterval);
    };
  }, [hasEcommerceStore]);

  // Real-time unread notification count via hybridSocket
  useEffect(() => {
    const handleUnreadUpdate = (payload) => {
      const count = typeof payload === 'number' ? payload : payload?.count;
      console.log('🔔 Dashboard: Received unread count update:', count);
      if (typeof count === 'number') {
        setUnreadNotifications(count);
        console.log('🔔 Dashboard: Updated unreadNotifications state to:', count);
      }
    };

    hybridSocket.on('notificationUnreadCountUpdated', handleUnreadUpdate);
    console.log('🔔 Dashboard: Registered socket listener for notificationUnreadCountUpdated');

    return () => {
      hybridSocket.off('notificationUnreadCountUpdated', handleUnreadUpdate);
      console.log('🔔 Dashboard: Unregistered socket listener');
    };
  }, []);

  // Real-time ecommerce order notifications via hybridSocket
  useEffect(() => {
    if (!hasEcommerceStore) return;

    const handleNewEcommerceOrder = (orderData) => {
      console.log('🛒 [ECOMMERCE] New order received:', orderData);
      setEcommercePendingCount(prev => prev + 1);
      
      // Show toast notification
      if (window.Swal) {
        window.Swal.fire({
          icon: 'info',
          title: 'New Ecommerce Order!',
          text: `Order from ${orderData?.customer?.name || 'Customer'} - ${orderData?.total?.toFixed(2) || '0.00'}`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true
        });
      }
    };

    hybridSocket.on('ecommerce:newOrder', handleNewEcommerceOrder);
    console.log('🛒 [ECOMMERCE] Registered socket listener for new orders');

    return () => {
      hybridSocket.off('ecommerce:newOrder', handleNewEcommerceOrder);
      console.log('🛒 [ECOMMERCE] Unregistered socket listener');
    };
  }, [hasEcommerceStore]);
  const shiftDenominationGetForm = (key) => (e) => {
    const { value } = e.target;
    if (key === "currency") {
      setShiftDenominationBody({ ...shiftDenominationBody, currency: value });
    }
    if (key === "amount") {
      setShiftDenominationBody({
        ...shiftDenominationBody,
        amount: value,
        total: shiftDenominationBody.count * value,
      });
    }
    if (key === "count") {
      setShiftDenominationBody({
        ...shiftDenominationBody,
        count: value,
        total: shiftDenominationBody.amount * value,
      });
    }
  };



  const shiftStatus = useSelector((state) => state.shiftStatusSlice.value);
  const allEmployees = useSelector((state) => state.allActiveEmployeeSlice.value);
  
  // Get shift report type from localStorage or shift status (must be after shiftStatus)
  const selectedShiftReportType = localStorage.getItem(`selectedShiftReportType_${userName}`) 
    || shiftStatus?.shiftReport 
    || "Advanced Shift Report"; // Default to Advanced Shift Report

  const closeSnackbar = () => {
    dispatch(setErrorSnack(false));
    dispatch(setSuccessSnack(false));

    setTimeout(() => {
      dispatch(setSnackMsg(""));
    }, 1000);
  };


  const handleStart = () => {
    increment.current = setInterval(() => {
      setTimer((timer) => timer + 1);
    }, 1000);
  };

  const handlePause = () => {
    clearInterval(increment.current);
  };
  const handleReset = () => {
    clearInterval(increment.current);
    setTimer(0);
  };

  const handleResume = () => {
    increment.current = setInterval(() => {
      setTimer((timer) => timer + 1);
    }, 1000);
  };

  // Resolve employee image from common HRM fields
  const resolveEmpImage = (emp) => {
    if (!emp) return null;
    return (
      emp?.profileImage ||
      emp?.photo ||
      emp?.imageUrl ||
      emp?.image ||
      emp?.staff_photo ||
      emp?.profilePic ||
      emp?.photoUrl ||
      (emp?.image && emp.image.url) ||
      (emp?.profile && (emp.profile.imageUrl || emp.profile.photo || emp.profile.profileImage)) ||
      null
    );
  };

  // Gender-based avatar fallback (same colors as indicator)
  const getGender = (emp) => {
    const g = (emp?.gender || emp?.sex || emp?.genderType || '').toString().toLowerCase();
    if (g.startsWith('f')) return 'female';
    if (g.startsWith('m')) return 'male';
    return 'unknown';
  };
  const ColoredAvatar = ({ emp, size = 28, circle = true }) => {
    const gender = getGender(emp);
    const bg = gender === 'female' ? '#f48fb1' : gender === 'male' ? '#90caf9' : '#bdbdbd';
    const style = { borderRadius: circle ? '50%' : '30px', height: size, width: size, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: bg, color: '#fff' };
    return (
      <div style={style}>
        {gender === 'female' ? (
          <WomanIcon sx={{ fontSize: size * 0.7 }} />
        ) : gender === 'male' ? (
          <ManIcon sx={{ fontSize: size * 0.7 }} />
        ) : (
          <PersonIcon sx={{ fontSize: size * 0.7 }} />
        )}
      </div>
    );
  };

  // shift button change function
  const shiftStartBtnFn = () => {
    startManualShiftAPICall(
      {
        branchId: storeCode,
        startDate: `${today} ${getCurrentTime()}`,
      },
      setShiftBtnState,
      shiftBtnState,
      handleReset,
      handleStart,
      setErrorSnackBar,
      setErrorMsg
    );
  };

  // const shiftEndBtnClick = () => {
  //   // setShiftBtnState(!shiftBtnState)
  //   if (shiftStatus !== null) {
  //     // shiftStatus.isDenomination
  //     //   ? setDenominationDialog(true)
  //       // : 
  //       setShiftEndPasswordDialog(true);
  //   }
  // };
  const shiftEndBtnClick = () => {
    // If any employee still checked-in, warn and block end
    const activeCheckedIn = Array.isArray(shiftStatus?.empCheckIn)
      ? shiftStatus.empCheckIn.filter((e)=>e?.checkInStatus)
      : [];
    if (activeCheckedIn.length > 0) {
      const empMapList = Array.isArray(allEmployees) ? allEmployees : [];
      const names = activeCheckedIn
        .map((e)=>{
          const emp = empMapList.find((x)=>x?._id===e.empId);
          return emp?.staff_name || e.empId?.slice(-4) || 'Unknown'
        })
        .join(', ');
      setErrorMsg(`Please checkout the following before ending shift: ${names}`);
      setErrorSnackBar(true);
      return;
    }
    if (shiftStatus?.isBranchWise === false) {
      getShiftEndDetail({ shiftId: userShiftCode })
    } else {
      setShiftEndPasswordDialog(true);
    }
  }
  useEffect(() => {
    if (shiftEndtDetail?.success === true) {
      setDenominationDialog(true)
    }
  }, [shiftEndtDetail])

  const shiftEndPasswordSubmitBtnClick = () => {
    endManualShiftAPICall(
      {
        branchId: userBranchpk,
        endDate: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(date.getDate()).padStart(2, "0")} ${String(
          date.getHours()
        ).padStart(2, "0")}:${String(date.getMinutes()).padStart(
          2,
          "0"
        )}:${String(date.getSeconds()).padStart(2, "0")}`,
      },
      handlePause,
      setShiftEndPasswordDialog,
      setShiftBtnState,
      shiftBtnState,
      setErrorSnackBar,
      setErrorMsg
    );
    localStorage.setItem("shitBtnState", JSON.stringify(!shiftBtnState));
    localStorage.removeItem("timer");
  };

  // Verify Password Function (especially for close shift)
  const verifyUserPassword = () => {
    if (verifyPassWord !== "") {
      let body;

      if (shiftStatus?.isBranchWise === true) {
        // Send only password
        body = { password: verifyPassWord };
      } else {
        // Send full body
        body = {
          password: verifyPassWord,
          endDate: `${today} ${getCurrentTime()}`,
          branchId: userBranchpk,
          empWiseCashCardReport: shiftEndtDetail?.data?.cashCardSummary?.data?.map(item => {
            const base = {
              name: item.name,
              type: item.type,
              journalId: item.journalId,
              totalAmount: item.totalAmount,
              totalCommission: item.totalCommission
            };

            if (item.type === "cash") {
              return {
                ...base,
                differance: difference,
                denomination: denomination,
                description: description
              };
            }

            return base;
          })
        };
      }

      verifyPasswordForShiftAPICall(
        body,
        setErrorSnackBar,
        setErrorMsg,
        shiftEndPasswordSubmitBtnClick
      );
    }
  };

  // snackbar function
  const errorSnackbarClose = () => {
    setErrorSnackBar(false);
  };
  const successSnackbarClose = () => {
    setSuccessSnackBar(false);
  };
  const clickAddSingleDenomination = () => {
    if (shiftDenominationBody.amount === "") {
      console.log("alert");
    } else if (shiftDenominationBody.count === "") {
      console.log("alert");
    } else {
      let singleObj = {
        currency: shiftDenominationBody.currency,
        amount: shiftDenominationBody.amount,
        count: shiftDenominationBody.count,
        total: shiftDenominationBody.total,
      };
      setShiftDenominationTable([...shiftDenominationTable, singleObj]);
      setShiftDenominationBody(shiftDenominationBodyInitialState);
    }
  };
  const clickDelSingleDenomination = (index) => () => {
    let duplicateArray = [...shiftDenominationTable];
    duplicateArray.splice(index, 1);
    setShiftDenominationTable(duplicateArray);
  };
  const clickEditSingleDenomination = (index) => () => {
    let duplicateArray = [...shiftDenominationTable];
    setShiftDenominationBody({
      ...shiftDenominationBody,
      currency: duplicateArray[index].currency,
      amount: duplicateArray[index].amount,
      count: duplicateArray[index].count,
      total: duplicateArray[index].total,
    });
    duplicateArray.splice(index, 1);
    setShiftDenominationTable(duplicateArray);
  };
  const denominationUpdated = () => {
    setDenominationDialog(false);
    setShiftDenominationTable([]);
    setShiftEndPasswordDialog(true);
  };
  const shiftAddDenominationPayload = {
    denomination: shiftDenominationTable,
    branchId: userBranchId,
    shiftId: userShiftId,
    date: today,
  };
  // const denominationSubmitBtn = () => {
  //   if (shiftDenominationTable.length !== 0) {
  //     addShiftDenominationAPICall(
  //       shiftAddDenominationPayload,
  //       denominationUpdated
  //     );
  //   }
  //   // setShiftEndPasswordDialog(true);
  // };

  const denominationSubmitBtn = () => {
    if (shiftDenominationTable.length !== 0) {
      addShiftDenominationAPICall(
        shiftAddDenominationPayload,
        () => {
          // Instead of navigating, show print preview
          setDenominationDialog(false);
          setShowPrintPreview(true);
        }
      );
    }
  };

  const [executeRequiringDialog, setExecuteRecurringDialog] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const showExecuteRecurringPostDialog = () => {
    // add data from localstorage
    const showExecuteRecurring = localStorage.getItem("accountExecute");
    if (showExecuteRecurring) {
      setExecuteRecurringDialog(true);
    } else {
      setExecuteRecurringDialog(false);
    }
  };
  const handleFullscreen = async () => {
    const isDocumentActive =
      typeof document?.hasFocus === "function"
        ? document.hasFocus() && document.visibilityState === "visible"
        : document.visibilityState === "visible";

    if (!isDocumentActive) {
      return;
    }

    const isActuallyFullscreen = Boolean(document.fullscreenElement);

    if (fullScreenEnable || isActuallyFullscreen) {
      if (!document.fullscreenElement) {
        setEnableFullScreen(false);
        return;
      }
      try {
        if (document.exitFullscreen) {
          await document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          await document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          await document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          await document.msExitFullscreen();
        }
        setEnableFullScreen(false);
      } catch (_) {
        setEnableFullScreen(Boolean(document.fullscreenElement));
      }
    } else {
      const elem = document.documentElement; // Select the entire document
      try {
        if (elem.requestFullscreen) {
          await elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          await elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          await elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          await elem.msRequestFullscreen();
        }
        setEnableFullScreen(true);
      } catch (_) {
        setEnableFullScreen(Boolean(document.fullscreenElement));
      }
    }
  };

  const shiftSummaryReportClick = () => {
    setShiftReportBtn(true)
    dispatch(set_shift_report_branch({ _id: userBranchpk }))
    dispatch(set_shift_report_shift({ _id: userShiftCode }))
    dispatch(set_shift_report_submit("submit"))
  }



  //denomination count
  const [entries, setEntries] = useState([{ currency: "", count: "" }]);

  const handleChange = (index, field, value) => {
    const updated = [...entries];
    updated[index][field] = value;
    setEntries(updated);
  };

  const addEntry = () => {
    const validEntries = entries.filter(e => e.currency && e.count);

    const denominationTotal = validEntries.reduce((sum, entry) => {
      const currency = parseFloat(entry.currency) || 0;
      const count = parseInt(entry.count) || 0;
      return sum + (currency * count);
    }, 0);

    const cashTypeTotal = checkOutPassDetail?.data?.cashCardSummary?.data
      ?.filter(item => item.type === "cash")
      ?.reduce((sum, item) => sum + (parseFloat(item.totalAmount) || 0), 0);

    if (denominationTotal > cashTypeTotal) {
      alert("Denomination total cannot exceed the expected cash total.");
      return;
    }

    // Add a new entry row
    setEntries([...entries, { currency: "", count: "" }]);
  };


  const deleteEntry = (index) => {
    setEntries(prev => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated.length ? updated : [{ currency: "", count: "" }];
    });
  };
  const toggleUpArrow = () => {
    setShowUpArrow(prev => {
      const open = !prev;
      if (open) {
        setEntries(denomination.length > 0 ? denomination : [{ currency: "", count: "" }]);
      }
      return open;
    });
  };
  const handleAddSubmit = () => {
    const validEntries = entries.filter(e => e.currency && e.count);

    // Check for duplicate currencies
    const currencySet = new Set();
    const hasDuplicate = validEntries.some(entry => {
      if (currencySet.has(entry.currency)) return true;
      currencySet.add(entry.currency);
      return false;
    });

    if (hasDuplicate) {
      alert("Duplicate currency values are not allowed.");
      return;
    }

    // Validate total denomination not exceeding the cash amount
    const cashAmount = (shiftStatus?.isBranchWise === true
      ? checkOutPassDetail?.data?.cashCardSummary?.data
      : shiftEndtDetail?.data?.cashCardSummary?.data
    )?.find(r => r.type === "cash")?.totalAmount || 0;

    const total = validEntries.reduce((sum, entry) => {
      const currency = parseFloat(entry.currency) || 0;
      const count = parseInt(entry.count) || 0;
      return sum + currency * count;
    }, 0);

    if (total > cashAmount) {
      alert("Total denomination exceeds available cash.");
      return;
    }

    setDenomination(validEntries);
    setEntries([{ currency: "", count: "" }]);
    setShowUpArrow(false);
  };


  const totalDenomination = denomination.reduce((sum, entry) => {
    const currency = parseFloat(entry.currency) || 0;
    const count = parseInt(entry.count) || 0;
    return sum + (currency * count);
  }, 0);
  const cashTypeTotal = checkOutPassDetail?.data?.cashCardSummary?.data
    ?.filter(item => item.type === "cash")
    ?.reduce((sum, item) => sum + (parseFloat(item.totalAmount) || 0), 0);

  const difference = cashTypeTotal - totalDenomination;
  // console.log(difference);

  // Receipt print handler using printDomAsPdfWithPopup for proper paper sizing
  const handleReceiptPrint = async () => {
    if (!receiptPrintRef.current) return;
    try {
      await printDomAsPdfWithPopup(receiptPrintRef.current, { widthMM: 80 });
    } catch (err) {
      console.error('Receipt print failed:', err);
    }
  };

  // Auto-trigger print when receipt dialog opens
  useEffect(() => {
    if (showReceiptPrintDialog && receiptPrintRef.current) {
      // Wait for API calls to complete and data to populate
      const timer = setTimeout(async () => {
        console.log('Auto-triggering receipt print after data load');
        await handleReceiptPrint();
        // Auto-close and navigate after print
        setTimeout(() => {
          setShowReceiptPrintDialog(false);
          dispatch(switch_to_billing_screen({ billingBoolean: false }));
          navigateTo('/userdashboard/dashboardhome');
        }, 1500);
      }, 3500); // Wait for API calls to complete
      
      return () => clearTimeout(timer);
    }
  }, [showReceiptPrintDialog]);

  // Auto-print shift report after checkout
  const handleAutoPrintAfterCheckout = () => {
    try {
      console.log('=== handleAutoPrintAfterCheckout called ===');
      
      // Get device settings from localStorage
      const printSettingsString = localStorage.getItem('PrinterSettings');
      const printSettings = printSettingsString ? JSON.parse(printSettingsString) : null;
      
      // Check if auto-print is enabled
      const isAutoPrintEnabled = printSettings?.receiptAuto === true;
      console.log('Auto-print enabled:', isAutoPrintEnabled);
      
      // Determine which report to print based on shift settings
      const shiftReportType = selectedShiftReportType;
      console.log('Selected shift report type:', shiftReportType);
      
      if (!isAutoPrintEnabled) {
        // If auto-print is disabled
        if (shiftReportType === "Advanced Shift Report") {
          // Show receipt print dialog
          console.log('Auto-print disabled + Advanced Shift Report: showing receipt print dialog');
          dispatch(set_shift_report_branch({ _id: userBranchpk }));
          dispatch(set_shift_report_shift({ _id: userShiftCode }));
          dispatch(set_shift_report_submit('submit'));
          
          // Show receipt print dialog
          setShowReceiptPrintDialog(true);
        } else {
          // Other report types -> show preview dialog
          console.log('Auto-print is disabled - preparing report context and showing print preview');
          dispatch(set_shift_report_branch({ _id: userBranchpk }));
          dispatch(set_shift_report_shift({ _id: userShiftCode }));
          dispatch(set_shift_report_submit('submit'));
          setShowPrintPreview(true);
        }
        return;
      }

      console.log('Auto-printing shift report:', shiftReportType);
      
      // Trigger print based on report type
      if (shiftReportType === "Advanced Shift Report") {
        // Use same compact Bill Type receipt print dialog (auto-triggers print)
        console.log('Auto-print enabled + Advanced Shift Report: showing receipt print dialog');
        dispatch(set_shift_report_branch({ _id: userBranchpk }));
        dispatch(set_shift_report_shift({ _id: userShiftCode }));
        dispatch(set_shift_report_submit('submit'));
        setShowReceiptPrintDialog(true);
      } else if (shiftReportType === "Shift Report") {
        // Print regular Shift Report
        console.log('Printing Shift Report, paymentsPrint available:', !!paymentsPrint.current);
        if (paymentsPrint.current) {
          // Wait a bit longer to ensure component is fully rendered
          setTimeout(() => {
            console.log('Triggering window.print() for Shift Report');
            window.print();
          }, 1000);
        } else {
          console.error('paymentsPrint.current is not available - component may not be mounted');
          // Try again after a delay
          setTimeout(() => {
            if (paymentsPrint.current) {
              console.log('Retry: paymentsPrint now available, triggering print');
              window.print();
            } else {
              console.error('Retry failed: paymentsPrint still not available');
            }
          }, 1500);
        }
      } else {
        console.warn('No matching shift report type found:', shiftReportType);
      }
    } catch (error) {
      console.error('Auto-print failed:', error);
    }
  };

  const refreshShiftRelatedData = () => {
    const shiftPayload = userShiftCode ? { shiftId: userShiftCode } : null;
    if (shiftPayload) {
      getCheckInDetail(shiftPayload);
      ListPosCheckinSummaryAPI(shiftPayload);
    }

    if (storeCode) {
      getShiftStatusAPICAll({
        branchId: storeCode,
        curTime: `${today} ${getCurrentTime()}`,
      });
    }
  };

  const handleSubmitheckout = () => {
    // Log checkout information for tracking
    const checkoutInfo = {
      employeeName: userInfo?.userName || 'Unknown',
      employeeId: employeeId,
      checkoutDate: today,
      checkoutTime: getCurrentTime(),
      shiftId: userShiftCode,
      branchId: userBranchpk
    };
    
    console.log('=== CHECKOUT INITIATED ===');
    console.log('Employee:', checkoutInfo.employeeName);
    console.log('Employee ID:', checkoutInfo.employeeId);
    console.log('Checkout Date:', checkoutInfo.checkoutDate);
    console.log('Checkout Time:', checkoutInfo.checkoutTime);
    console.log('Shift ID:', checkoutInfo.shiftId);
    console.log('Branch ID:', checkoutInfo.branchId);
    console.log('========================');
    
    const body = {
      postDate: `${today} ${getCurrentTime()}`,
      shiftId: userShiftCode,
      employeeName: userInfo?.userName,
      employeeId: employeeId,
      cashCardReport: checkOutPassDetail?.data?.cashCardSummary?.data?.map(item => {
        const base = {
          type: item.type,
          journalId: item.journalId,
          totalAmount: item.totalAmount,
          name: item.name,
          totalCommission: item.totalCommission
        };

        if (item.type === "cash") {
          return {
            ...base,
            differance: difference,
            denomination: denomination,
            description: description

          };
        }

        return base;
      })
    };
    
    // Pass auto-print callback to checkout submit
    getCheckOutSubmit(body, (responseData) => {
      console.log('=== CHECKOUT COMPLETED ===');
      console.log('Employee:', checkoutInfo.employeeName, 'successfully checked out');
      console.log('========================');

      refreshShiftRelatedData();

      // Trigger auto-print after successful checkout with a small delay
      // to ensure Redux state is updated
      setTimeout(() => {
        handleAutoPrintAfterCheckout();
      }, 300);
    });

  }



  const isCheckedOut = checkOutDetail?.data?.checkOut === true || checkOutDetail?.data?.checkOut === "true";

  useEffect(() => {
    if (isCheckedOut) {
      // Close the checkout popup
      setShowFinalCheckOutPopup(false);
      
      // Get device settings to check if we need to wait for print preview
      const printSettingsString = localStorage.getItem('PrinterSettings');
      const printSettings = printSettingsString ? JSON.parse(printSettingsString) : null;
      const isAutoPrintEnabled = printSettings?.receiptAuto === true;
      const shiftReportType = selectedShiftReportType;
      
      // If auto-print is disabled
      if (!isAutoPrintEnabled) {
        if (shiftReportType === "Advanced Shift Report") {
          // Receipt print will handle navigation after print completes
          console.log('Auto-print disabled - receipt print will navigate after completion');
          setTimeout(() => {
            dispatch(switch_to_billing_screen({ billingBoolean: false }));
            navigateTo('/userdashboard/dashboardhome');
          }, 2500); // Wait for receipt print to complete
        } else {
          // Print preview dialog will handle navigation via buttons
          console.log('Auto-print disabled - print preview will handle navigation');
        }
        return;
      }
      
      // If auto-print is enabled, navigate after a delay
      if (isAutoPrintEnabled) {
        setTimeout(() => {
          dispatch(switch_to_billing_screen({ billingBoolean: false }));
          navigateTo('/userdashboard/dashboardhome');
        }, 2000); // Wait for auto-printing
      }
    }
  }, [isCheckedOut, dispatch, navigate, selectedShiftReportType]);

  //verify checkout password
  // const VerifyCheckOutPass=(password)=>{
  // const body={
  //   password:password,
  //   shiftId: userShiftCode,
  // }
  // getCheckOutDetail(body)
  // };
  // const VerifyCheckOutPass = async (password) => {
  //   const body = {
  //     password: password,
  //     shiftId: userShiftCode,
  //   };

  //   try {
  //     const checkoutResult = await getCheckOutDetail(body);
  //     if (checkoutResult && branchConfigurationList?.enableWhatsApp) {
  //       const billingNumbers = branchConfigurationList.whatsAppShiftReport?.billingAdvanceShift || [];
  //       const salesNumbers = branchConfigurationList.whatsAppShiftReport?.salesShift || [];

  //       console.log('Billing numbers:', billingNumbers);
  //       console.log('Sales numbers:', salesNumbers);

  //       const sendTasks = [];

  //       if (billingNumbers.length > 0 && billingNumbers[0].phoneNumber) {
  //         sendTasks.push(
  //           sendShiftReport({
  //             numbers: billingNumbers,
  //             reportType: "Billing",
  //             printerRef: printRef.current
  //           }).catch(e => {
  //             console.error('Billing report error:', e);
  //             return { error: e.message };
  //           })
  //         );
  //       }

  //       if (salesNumbers.length > 0 && salesNumbers[0].phoneNumber) {
  //         sendTasks.push(
  //           sendShiftReport({
  //             numbers: salesNumbers,
  //             reportType: "Sales",
  //             printerRef: paymentsPrint.current
  //           }).catch(e => {
  //             console.error('Sales report error:', e);
  //             return { error: e.message };
  //           })
  //         );
  //       }

  //       const results = await Promise.all(sendTasks);
  //       console.log('All results:', results);
  //     }
  //   } catch (error) {
  //     console.error("Checkout failed:", error);
  //   }
  // };
  // const sendShiftReport = async ({ numbers, reportType, printerRef }) => {
  //   if (!printerRef) return;

  //   const message = `Hi, here is your ${reportType} report:`;

  //   // Render PDF
  //   const canvas = await html2canvas(printerRef, { scale: 2 });
  //   const imgData = canvas.toDataURL("image/png");
  //   const pdf = new jsPDF({
  //     orientation: "portrait",
  //     unit: "pt",
  //     format: [canvas.width, canvas.height],
  //   });
  //   pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
  //   const pdfBlob = pdf.output("blob");

  //   // Send to each number
  //   const sendTasks = numbers.map(async (numberObj) => {
  //     if (!numberObj.phoneNumber) return;

  //     const formData = new FormData();
  //     formData.append("userId", userBranchIdWS);
  //     formData.append("phoneNumber", `${numberObj.countryCode}${numberObj.phoneNumber}`);
  //     formData.append("message", message);
  //     formData.append("file", pdfBlob, `${reportType.toLowerCase()}_report.pdf`);

  //     return sendWhatsAppMessageAPI(formData, () => { }, () => { });
  //   });

  //   return Promise.all(sendTasks);
  // };
const VerifyCheckOutPass = async (password) => {
  const body = {
    password: password,
    shiftId: userShiftCode,
  };
  

  try {
   
    const checkoutResult = await getCheckOutDetail(body);
    if (!checkoutResult || !branchConfigurationList?.enableWhatsApp) {
      return;
    }

    const { billingAdvanceShift: billingNumbers = [], salesShift: salesNumbers = [] } = 
      branchConfigurationList.whatsAppShiftReport || {};

    const sendTasks = [];

    // Send advance shift report to billing numbers
    if (billingNumbers.length > 0) {
      sendTasks.push(
        sendShiftReport({
          numbers: billingNumbers,
          reportType: "Billing",
          printerRef: printRef.current
        })
      );
    }

    // Send regular shift report to sales numbers
    if (salesNumbers.length > 0) {
      sendTasks.push(
        sendShiftReport({
          numbers: salesNumbers,
          reportType: "Sales",
          printerRef: paymentsPrint.current
        })
      );
    }

    const allResults = await Promise.all(sendTasks);

    // Analyze results
    const failedSends = allResults.flatMap(result => 
      result.results?.filter(r => r.status === "failed") || []
    );

    if (failedSends.length > 0) {
      errorSnackMsg(`Failed to send ${failedSends.length} report(s)`);
      
    } else {
      successSnackMsg("All reports sent successfully");
     
    }

    console.log('Detailed send results:', allResults);
  } catch (error) {
    console.error("Checkout failed:", error);

    if (error?.response?.status === 409) {
      successSnackMsg("Checkout already completed");
      refreshShiftRelatedData();
      setShowCheckOutPopup(false);
      setShowSecondCheckOutPopup(false);
      setShowFinalCheckOutPopup(false);
      return;
    }

    errorSnackMsg("Checkout process failed");
  
  } finally {
    console.log("Checkout process completed");
  }
};
// const VerifyCheckOutPass = async (password) => {
//   const body = {
//     password: password,
//     shiftId: userShiftCode,
//   };

//   try {
//     const checkoutResult = await getCheckOutDetail(body);
//     if (!checkoutResult || !branchConfigurationList?.enableWhatsApp) {
//       return;
//     }

//     const { billingAdvanceShift: billingNumbers = [], salesShift: salesNumbers = [] } = 
//       branchConfigurationList.whatsAppShiftReport || {};

//        if (!printRef.current || !paymentsPrint.current) {
//       console.error('Refs not ready:', {
//         printRef: printRef.current,
//         paymentsPrint: paymentsPrint.current
//       });
//       errorSnackMsg("Reports not ready - please try again");
//       return;
//     }
//     console.log('printRef.current:', printRef.current);  
//     console.log('paymentsPrint.current:', paymentsPrint.current);

//     const sendTasks = [];

//     // Send advance shift report to billing numbers
//     if (billingNumbers.length > 0) {
//       sendTasks.push(
//         sendShiftReport({
//           numbers: billingNumbers,
//           reportType: "Billing",
//           printerRef: printRef.current
//         })
//       );
//     }

//     // Send regular shift report to sales numbers
//     if (salesNumbers.length > 0) {
//       sendTasks.push(
//         sendShiftReport({
//           numbers: salesNumbers,
//           reportType: "Sales",
//           printerRef: paymentsPrint.current
//         })
//       );
//     }

//     const allResults = await Promise.all(sendTasks);

//     // Analyze results
//     const failedSends = allResults.flatMap(result => 
//       result.results?.filter(r => r.status === "failed") || []
//     );

//     if (failedSends.length > 0) {
//       errorSnackMsg(`Failed to send ${failedSends.length} report(s)`);
      
//     } else {
//       successSnackMsg("All reports sent successfully");
     
//     }

//     console.log('Detailed send results:', allResults);
//   } catch (error) {
//     console.error("Checkout failed:", error);
//     errorSnackMsg("Checkout process failed");
   
//   } finally {
//     console.log("Checkout process completed");
//   }
// };
const sendShiftReport = async ({ numbers, reportType, printerRef }) => {
  console.log('Attempting to send:', reportType, 'with ref:', printerRef);
  
  if (!printerRef) {
    console.error('printerRef is null for:', reportType);
    errorSnackMsg("Report template not available");
    return {
      error: "No printer reference provided",
      numbers,
      reportType
    };
  }

  try {
    // Store original styles
    const originalStyles = {
      display: printerRef.style.display,
      position: printerRef.style.position,
      visibility: printerRef.style.visibility
    };

    // Make printable
    printerRef.style.display = 'block';
    printerRef.style.position = 'absolute';
    printerRef.style.visibility = 'hidden';

    // Generate PDF
    const canvas = await html2canvas(printerRef, {
      scale: 2,
      logging: true,
      useCORS: true,
      backgroundColor: '#FFFFFF',
      onclone: (clonedDoc) => {
        // Ensure cloned elements are visible
        const clone = clonedDoc.getElementById(printerRef.id) || printerRef;
        clone.style.display = 'block';
        clone.style.visibility = 'visible';
        clone.style.position = 'absolute';
      }
    });

    // Restore original styles immediately
    printerRef.style.display = originalStyles.display;
    printerRef.style.visibility = originalStyles.visibility;
    printerRef.style.position = originalStyles.position;

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: [canvas.width, canvas.height],
    });
    
    pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, canvas.width, canvas.height);
    const pdfBlob = pdf.output("blob");

    // Process each number
    const results = [];
    for (const numberObj of numbers) {
      if (!numberObj?.phoneNumber) {
        results.push({
          number: numberObj,
          status: "skipped",
          reason: "No phone number"
        });
        continue;
      }

      const formData = new FormData();
      formData.append("userId", userBranchIdWS);
      formData.append("phoneNumber", `${numberObj.countryCode || ''}${numberObj.phoneNumber}`);
      formData.append("message", `${reportType} Shift Report`);
      
      // Create PDF file with proper filename
      const pdfFile = new File([pdfBlob], `${reportType}_shift_report.pdf`, {
        type: "application/pdf"
      });
      formData.append("file", pdfFile);

      try {
        const result = await sendWhatsAppMessageAPIDashboard(formData);
        results.push({
          number: numberObj,
          status: "success",
          data: result
        });
      } catch (error) {
        results.push({
          number: numberObj,
          status: "failed",
          error: error.message
        });
      }
    }

    return {
      reportType,
      status: "completed",
      results
    };

  } catch (error) {
    console.error("PDF generation error:", error);
    errorSnackMsg("Failed to generate report PDF");
    return {
      reportType,
      status: "failed",
      error: error.message,
      numbers
    };
  }
};
// const sendShiftReport = async ({ numbers, reportType, printerRef }) => {
//   if (!printerRef) {
//     errorSnackMsg("Report template not available");
//     return {
//       error: "No printer reference provided",
//       numbers,
//       reportType
//     };
//   }

//   try {
//     // Store original styles
//     const originalStyles = {
//       display: printerRef.style.display,
//       position: printerRef.style.position,
//       visibility: printerRef.style.visibility
//     };

//     // Make printable
//     printerRef.style.display = 'block';
//     printerRef.style.position = 'absolute';
//     printerRef.style.visibility = 'hidden';

//     // Generate PDF
//     const canvas = await html2canvas(printerRef, {
//       scale: 2,
//       logging: true,
//       useCORS: true,
//       backgroundColor: '#FFFFFF' // Ensure white background
//     });

//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "pt",
//       format: [canvas.width, canvas.height],
//     });
    
//     pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, canvas.width, canvas.height);
//     const pdfBlob = pdf.output("blob");

//     // Restore original styles
//     Object.assign(printerRef.style, originalStyles);

//     // Process each number
//     const results = [];
//     for (const numberObj of numbers) {
//       if (!numberObj?.phoneNumber) {
//         results.push({
//           number: numberObj,
//           status: "skipped",
//           reason: "No phone number"
//         });
//         continue;
//       }

//       const formData = new FormData();
//       formData.append("userId", userBranchIdWS);
//       formData.append("phoneNumber", `${numberObj.countryCode || ''}${numberObj.phoneNumber}`);
//       formData.append("message", `${reportType} Shift Report`);
      
//       // Create PDF file with proper filename
//       const pdfFile = new File([pdfBlob], `${reportType}_shift_report.pdf`, {
//         type: "application/pdf"
//       });
//       formData.append("file", pdfFile);

//       try {
//         const result = await sendWhatsAppMessageAPIDashboard(formData);
//         results.push({
//           number: numberObj,
//           status: "success",
//           data: result
//         });
//       } catch (error) {
//         results.push({
//           number: numberObj,
//           status: "failed",
//           error: error.message
//         });
//       }
//     }

//     return {
//       reportType,
//       status: "completed",
//       results
//     };

//   } catch (error) {
//     console.error("PDF generation error:", error);
//     errorSnackMsg("Failed to generate report PDF");
//     return {
//       reportType,
//       status: "failed",
//       error: error.message,
//       numbers
//     };
//   }
// };
// useEffect(() => {
//   console.log('Component mounted - Refs:', {
//     printRef: printRef.current,
//     paymentsPrint: paymentsPrint.current
//   });

//   return () => {
//     console.log('Component unmounted');
//   };
// }, []);
  useEffect(() => {
    if (checkOutPassDetail?.success === true) {
      setShowSecondCheckOutPopup(false)
      setShowFinalCheckOutPopup(true);
    }
  }, [checkOutPassDetail]);


  const branchesRequestedRef = useRef(false);
  const heavyInitRef = useRef(false);

  // initial apicalls
  useEffect(() => {
    const onboardingActive = needsSetup || branchName === "noBranch";
    const checkinBody = {
      shiftId: shiftStatus?._id,
    };

    if (!branchesRequestedRef.current) {
      viewAllBranchesAPICall();
      branchesRequestedRef.current = true;
    }

    const hasBranches = Array.isArray(allBranchesList) && allBranchesList.length > 0;

    if (!heavyInitRef.current && !needsSetup && hasBranches) {
      heavyInitRef.current = true;

      if (!selfUser) {
        showExecuteRecurringPostDialog();
        viewCashInOrCashOutAPICall();
        viewGlConfigAPICall();
        getAllNewProductList();
        vendorListApi();
        viewInventoryConfigSettingsAPICall();
        employeeRolesAndPermission({ _id: employeeId });
      }
      viewAllCurrencyUpdated({ status: 0 });
      viewPosSettingsAPICall();
      if (userBranchpk && userBranchpk !== "noBranch") {
        getAllActiveEmployeesAPICall();
        getEmployeesByBranch(userBranchpk);
      } else {
        console.warn("⏭️ Skipping employee fetch until branch is selected");
      }
      customerListApi();
      companyProfileInfoForUser();
      if (checkinBody.shiftId) {
        ListPosCheckinSummaryAPI(checkinBody);
      }
    }

    if (userInfo !== undefined) {
      if (userInfo !== null) {
        const { branchName } = userInfo;
        setBranchName(branchName);
      }
    }

    if (!needsSetup && hasBranches && userRole === "user") {
      let branchId = localStorage.getItem("branchId");
      getShiftStatusAPICAll({
        branchId,
        curTime: `${today} ${getCurrentTime()}`,
      });
    }
  }, [needsSetup, allBranchesList]);

  useEffect(() => {
    if (shiftDenominationTable.length !== 0) {
      let totalAmtArray = [];
      totalAmtArray = shiftDenominationTable.map((obj) => obj?.total);
      let grandTotal = 0;
      grandTotal = totalAmtArray.reduce((a, b) => a + b, 0);
      setShiftDenominationGrandTotal(grandTotal);
    }
  }, [shiftDenominationTable]);

  useEffect(() => {
    if (userRole === "user") {
      let shiftBtnState = null;
      let timerLS = null;
      if (shiftStatus !== null) {
        shiftBtnState = shiftStatus?.status === "Active" ? true : false;
        timerLS = shiftStatus?.timer;
        setShiftBtnState(shiftBtnState);
        // setTimer(timerLS || 0);
      }
    }
  }, [shiftStatus]);

  //Call resume or pause on change of shift status
  useEffect(() => {
    if (JSON.parse(shiftBtnState)) {
      if (timer !== 0 && timer !== null) handleResume();
    } else {
      handlePause();
    }
  }, [shiftBtnState]);

  // to set default user and branch
  useEffect(() => {
    if (allActiveEmpList !== undefined) {
      let employeeObj = allActiveEmpList?.find((obj) => obj?._id === userInfo?.data?._id)
      dispatch(setEmployeeDetails(employeeObj || null))
    }
    if (allBranchesList !== undefined && Array.isArray(allBranchesList) && allBranchesList.length > 0) {
      let employeeBranch = allBranchesList?.find((obj) => obj?._id === userBranchpk)
      dispatch(setBranchDetails(employeeBranch || null))
      dispatch(setNeedsSetup(false));
    } else if (allBranchesList === undefined) {
      dispatch(setNeedsSetup(true));
    }
    if (companyProfileData !== undefined && currencyListUpdated !== undefined) {
      let companyCurrency = currencyListUpdated?.find((obj) => obj?._id === companyProfileData?.currency)
      dispatch(setCurrencyDetails(companyCurrency || null))
    }
  }, [allActiveEmpList, allBranchesList, currencyListUpdated, companyProfileData])


  const { templatekot } = useSelector(
    (state) => state.kotTokenDisplaySlice
  );
  let navigateTo = useNavigate();
  const handleNavigateToSetup = () => {
    navigateTo("/userdashboard/settings/companyprofile");
  };

  const onboardingAllowedPaths = [
    "/userdashboard/settings",
    "/userdashboard/settings/companyprofile",
  ];
  const isNavigatingToSetup = onboardingAllowedPaths.some((path) =>
    location.pathname.startsWith(path)
  );
  const shouldShowOnboarding = needsSetup && !isNavigatingToSetup;

  const renderSetupEmptyState = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          minHeight: "calc(100vh - 120px)",
          gap: 3,
          px: 4,
        }}
      >
        <img
          src={companyProfileData?.logoUrl || "https://cdn-icons-png.flaticon.com/512/9433/9433914.png"}
          alt="Set up illustration"
          style={{ width: 160, height: 160, objectFit: "contain", opacity: 0.4 }}
        />
        <Stack spacing={1} maxWidth={480}>
          <h2 style={{ margin: 0 }}>Let’s finish setting up your workspace</h2>
          <p style={{ margin: 0, color: "#555" }}>
            We couldn’t find any outlets for this company yet. Complete the company profile to create
            your first branch, default warehouse, and shift configuration.
          </p>
        </Stack>
        <Button variant="contained" color="primary" onClick={handleNavigateToSetup}>
          Go to Company Profile
        </Button>
      </Box>
    );
  };

  return (
    <>
      <ThemeProvider theme={mdTheme} >
        <Box sx={{ display: "flex" }} className={(hideHeader || selfUser || localStorage.getItem("portableMode") === "active") && "top-hide"}>
          {
            !selfUser && localStorage.getItem("portableMode") !== "active" &&
            <>
              <CssBaseline />
              <AppBar
                position="fixed"
                open={false}
                sx={{ ...(billingScreen && { marginLeft: "0px", width: "100%" }) }}
              >
                <Toolbar
                  sx={{
                    pr: "24px",
                    backgroundColor: "#fff",
                    display: hideHeader ? 'none' : 'flex',
                    margin: "0px !important",
                    ...(billingScreen && { minHeight: 'unset !important', py: '2px', transition: 'all 0.2s ease' }),
                    ...(billingScreen && billingHeaderCollapsed && { minHeight: '0px !important', height: '0px', py: '0 !important', overflow: 'hidden', transition: 'all 0.2s ease' }),
                  }}
                >
                  <div className="dashboard-top-container desktop-logout" style={billingScreen ? { height: 'auto', minHeight: 0 } : {}}>
                    {(userRole === "user" && (
                      <div
                        className="dashboard-top-container-left-side"
                        style={{ width: "50%", justifyContent: "normal" }}
                      >
                        <div
                          className="user-info"
                        >
                          <Avatar
                            src={userInfo?.imageUrl}
                            sx={billingScreen ? { width: 28, height: 28 } : {}}
                          />

                          <p style={{ color: "black" }}>{userInfo?.userName}</p>
                        </div>
                        {/* )} */}
                        <div
                          className="dashboard-shift-status-main-container"
                          style={{ width: "45%" }}
                        >
                          <div className="shift-status">
                            <p>
                              Shift
                              <span style={{ color: "red", marginLeft: "5px" }}>
                                {shiftStatus?.transNo}
                              </span>
                            </p>
                            <div className="shift-status-active">
                              {shiftBtnState === true ? (
                                <div className="shift-status-active-round"></div>
                              ) : (
                                <div
                                  className="shift-status-active-round"
                                  style={{ backgroundColor: "rgb(173 168 168)" }}
                                ></div>
                              )}
                              {shiftBtnState === true ? (
                                <p>Active</p>
                              ) : (
                                <p style={{ color: "rgb(173 168 168)" }}>
                                  Inactive
                                </p>
                              )}
                            </div>
                          </div>
                          <ShiftTimerComponent />
                        </div>
                        {shiftBtnState ? (
                          <button
                            style={{ height: "30px", margin: "0 2%" }}
                            onClick={shiftEndBtnClick}
                            className="start-button end-button"
                          >
                            End
                          </button>
                        ) : (
                          <button
                            style={{ height: "30px", margin: "0 2%" }}
                            onClick={shiftStartBtnFn}
                            className="start-button"
                          >
                            Start
                          </button>
                        )}

                        {posSettingsList?.cashInOutStatus === true && (
                          <button
                            style={{
                              width: "25%",
                              borderRadius: "4px",

                              backgroundColor: "#087baf",

                              color: "#fff",
                              border: "none",
                              height: "30px",
                              cursor: "pointer",

                              // margin: "0 2%",
                              maxWidth: "fit-content"
                            }}
                            onClick={() => dispatch(setCashInOrOutDialog(true))}
                          >
                            Cash In Or Out
                          </button>
                        )}
                        {(() => {
                          const list = Array.isArray(shiftStatus?.empCheckIn) ? shiftStatus.empCheckIn : [];
                          const isCurrentUserCheckedIn = list.some((e)=>e?.empId===employeeId && e?.checkInStatus);
                          const othersActive = list.filter((e)=>e?.checkInStatus && e?.empId !== employeeId);
                          if (!isCurrentUserCheckedIn && othersActive.length > 0) {
                            const text = othersActive
                              .map((e)=>{
                                const emp = Array.isArray(allEmployees) ? allEmployees.find((x)=>x?._id===e.empId) : null;
                                return emp?.staff_name || e.empId?.slice(-4) || 'Unknown';
                              })
                              .join(', ');
                            return (
                              <div style={{marginLeft: 8, fontSize: 12, color: '#444'}}>
                                <span style={{fontWeight: 600}}>Checked-in:</span>&nbsp;{text}
                              </div>
                            );
                          }
                          return null;
                        })()}
                        {/* Employee Check-in status indicator */}
                        <CheckInStatusIndicator onCheckoutClick={(emp) => { setSelectedCheckoutEmployee(emp || null); setShowCheckOutPopup(true); }} />
                      </div>
                    )) || <div className="dashboard-top-container-left-side"></div>}

                    <div className="dashboard-top-container-right-side">
                      <div className="role-branch-code-container">
                        <div className="role-branch-child">
                          <span className="head-role">Role</span>
                          <span>:&nbsp;&nbsp;</span>
                          <span
                            style={{
                              color: "#1ebe69",
                              textTransform: "capitalize",
                            }}
                          >
                            {userRole}
                          </span>
                        </div>
                        {branchName !== "noBranch" && branchName !== "..." && (
                          <div className="role-branch-child">
                            <span className="head">Branch</span>
                            <span>:&nbsp;&nbsp;</span>
                            <span style={{ color: "#1ebe69" }}>{branchName}</span>
                          </div>
                        )}
                      </div>

                      {/* icons */}
                      <Tooltip title="Live Chat">
                        <IconButton>
                          <i className="bi bi-chat-text chat-icon"></i>
                        </IconButton>
                      </Tooltip>
                      {/* Real-time Notifications Bell (navigates to Notification Center) with Lottie icon */}
                      <Tooltip title="Notifications">
                        <IconButton
                          onClick={() => navigate('/userdashboard/staff/hrm/notifications')}
                          size="large"
                        >
                          <Badge
                            badgeContent={unreadNotifications}
                            max={9999}
                            color="error"
                            overlap="circular"
                          >
                            <div
                              ref={notificationLottieRef}
                              style={{ width: 32, height: 32 }}
                            />
                          </Badge>
                        </IconButton>
                      </Tooltip>
                      {/* Existing notification popup (detailed drawer/modal) */}
                      <Tooltip title="Notification Feed">
                        <div style={{ position: 'relative', zIndex: 1 }}>
                          <NotificationPopup />
                        </div>
                      </Tooltip>
                      {hasEcommerceStore && userRole !== 'admin' ? (
                        <Tooltip title="Ecommerce Orders">
                          <IconButton
                            onClick={() => setEcommerceNotificationOpen(true)}
                            size="large"
                          >
                            <Badge
                              badgeContent={ecommercePendingCount}
                              color="error"
                              overlap="circular"
                            >
                              <StorefrontOutlinedIcon />
                            </Badge>
                          </IconButton>
                        </Tooltip>
                      ) : null}
                      <Tooltip title="Online/Offline Status">
                        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                          <SyncStatusIndicator />
                        </div>
                      </Tooltip>
                      <Tooltip title="Sync Session Data">
                        <div>
                          <SyncSessionDataButton />
                        </div>
                      </Tooltip>
                      <Stack direction={"row"} className="desktop-logout">
                        <Chip
                          label="Log Out"
                          onClick={logOutUser(
                            true,
                            userRole,
                            shiftBtnState,
                            shiftEndBtnClick
                          )}
                          icon={
                            <PowerSettingsNewIcon
                              style={{ fontSize: 16, color: "red" }}
                            />
                          }
                          style={{
                            fontWeight: 600,
                            color: "#000",
                            backgroundColor: "#f4f4f4",
                            marginLeft: 8,
                            cursor: "pointer",
                            border: "2px solid orange",
                          }}
                        ></Chip>
                      </Stack>

                      {
                        billingScreen && (
                          <IconButton
                            onClick={() => {
                              if (shiftStatus?.isBranchWise === false) {
                                dispatch(switch_to_billing_screen({ billingBoolean: false }));
                                navigate("/userdashboard/dashboardhome");
                              } else {
                                setShowCheckOutPopup(true);
                              }
                            }}
                          >

                            <HighlightOffOutlinedIcon
                              sx={{
                                color: "#f93737",
                                fontSize: "30px",
                                fontWeight: "400",
                              }}
                            />
                          </IconButton>
                        )
                      }
                    </div>



                    {/* show Execute Recurring Post */}
                    <Dialog
                      open={executeRequiringDialog}
                      onClose={() => setExecuteRecurringDialog(false)}
                      maxWidth="lg"
                    >
                      <div className="execute-recurring-post">
                        <div
                          style={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <button
                            onClick={() => setExecuteRecurringDialog(false)}
                            className="close-btn"
                          >
                            <HighlightOffIcon fontSize="large" />
                          </button>
                        </div>

                        <div className="execute-recurring-post-container">
                          <h3>Execute Recurring Post</h3>
                          <div className="execute-recurring-btn-container">
                            <button
                              onClick={() => {
                                setExecuteRecurringDialog(false);
                                navigate(
                                  "/userdashboard/accounts/createinvoice/recurringposting"
                                );
                              }}
                              className="btn btn-red"
                            >
                              YES
                            </button>
                            <button
                              onClick={() => setExecuteRecurringDialog(false)}
                              className="btn btn-black"
                            >
                              No
                            </button>
                          </div>
                        </div>
                      </div>
                    </Dialog>

                    {/* password dialog */}
                    <Dialog
                      open={shiftEndPasswordDialog}
                      onClose={() => setShiftEndPasswordDialog(false)}
                      maxWidth="lg"
                    >
                      <div className="shift-end-button-password-container">
                        <div className="justify-space-between">
                          <h3>Enter Password</h3>
                          <Tooltip title="Shift Report">
                            <IconButton onClick={shiftSummaryReportClick}>
                              <ReceiptLongIcon color="primary" />
                            </IconButton>
                          </Tooltip>
                        </div>
                        <div className="global-single-input shit-end-password-input">
                          <p>Password</p>
                          <input
                            type="password"
                            value={verifyPassWord}
                            onKeyDown={(e) =>
                              e.key === "Enter"
                                ? verifyUserPassword()
                                : e.key === "Escape"
                                  ? () => setShiftEndPasswordDialog(false)
                                  : undefined
                            }
                            onChange={(e) => {
                              setVerifyPassword(e.target.value);
                            }}
                          />
                        </div>
                        <button
                          onClick={verifyUserPassword}
                          className="btn btn-primary shift-end-password-btn"
                        >
                          Submit
                        </button>
                      </div>
                    </Dialog>
                    {/* error snackbar */}
                    <ErrorSnackbar
                      open={errorSnackBar}
                      handleClose={errorSnackbarClose}
                      message={errorMsg}
                    />
                    <SuccessSnackbar
                      open={sucessSnackBar}
                      handleClose={successSnackbarClose}
                      message={errorMsg}
                    />

                    {/* SHIFT end denomination dialog */}

                    {denominationDialog && (
                      <div className="popup-overlay">
                        <div className="popup-box" style={{ width: "387px", borderRadius: "10px", overflow: "hidden" }}>

                          {/* Top bar with user name and image */}
                          <div style={{ backgroundColor: "#14008C", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px", color: "white" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <img src={photo} alt="" style={{ borderRadius: "50%", height: "35px", width: "35px" }} />
                              <span style={{ fontWeight: "bold" }}>{userInfo?.userName}</span>
                            </div>
                            <IconButton onClick={() => setDenominationDialog(false)} style={{ color: "white" }}>
                              <HighlightOffOutlinedIcon />
                            </IconButton>
                          </div>
                          {/* Content */}
                          <div style={{ padding: "15px", backgroundColor: "#fff" }}>
                            <h4 style={{ margin: "1px 0px 15px 0px", justifySelf: "start", fontWeight: "400" }}>Denomination</h4>
                            <div style={{ display: "flex", justifyContent: "space-between", color: "black", marginBottom: "10px", paddingInline: "9px", borderRadius: "3px", backgroundColor: "rgb(163 160 160)" }}>
                              <span>Total</span>
                              <span >{shiftEndtDetail?.data?.cashCardSummary?.amountTotal || "0.00"}</span>
                            </div>
                            {/* Payment modes */}

                            {(() => {
                              const filteredData = shiftEndtDetail?.data?.cashCardSummary?.data?.filter(r => !showUpArrow || r.type === "cash");

                              if (!filteredData || filteredData.length === 0) {
                                return <div style={{ padding: "10px", color: "#888", textAlign: "center" }}>No Record Found</div>;
                              }

                              return filteredData.map((r, i) => (
                                <div
                                  key={i}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    margin: "7px 0",
                                    paddingLeft: "7px",
                                    border: "solid 1px #bbb9b9",
                                    backgroundColor: "#e1dfdf",
                                    borderRadius: "5px",
                                    color: "black",
                                    padding: r.type !== "cash" || shiftStatus?.isDenomination === false ? "5px" : "0 0 0 6px"
                                  }}
                                >
                                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <span>{r.name}</span>
                                  </div>

                                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <span>{Number(r.totalAmount).toFixed(2)}</span>
                                    {r.type === "cash" && shiftStatus?.isDenomination === true && (
                                      <span
                                        onClick={toggleUpArrow}
                                        style={{ padding: "6px 4px", backgroundColor: "#f9c9c9", cursor: "pointer" }}
                                      >
                                        {showUpArrow ? (
                                          <ArrowUpwardIcon style={{ color: "red", fontSize: "18px" }} />
                                        ) : (
                                          <ArrowDownwardIcon style={{ color: "red", fontSize: "18px" }} />
                                        )}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              ));


                            })()}
                            {shiftStatus?.isDenomination === true && (
                              <textarea
                                placeholder="description for denomination.."
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                style={{
                                  width: "100%",
                                  minHeight: "60px",
                                  padding: "8px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  resize: "vertical",
                                  backgroundColor: "rgb(245 241 241)"
                                }}
                              />
                            )}

                            {!showUpArrow && (
                              <>
                                {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0" ,padding:"7px", border:"solid 1px #bbb9b9",backgroundColor:"#e1dfdf", borderRadius:"5px"}}>
          <img src={card} alt="" style={{ width: "40px", height: "25px" }} />
          <span>552.00</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0",padding:"7px", border:"solid 1px #bbb9b9",backgroundColor:"#e1dfdf", borderRadius:"5px" }}>
          <img src={UPI} alt="" style={{ width: "40px", height: "25px" }} />
          <span>8,545.00</span>
        </div> */}

                                <h4 style={{ margin: "21px 0px 7px 0px", justifySelf: "start", fontWeight: "400" }}>Order Total</h4>
                                {(() => {
                                  const posOrders = shiftEndtDetail?.data?.posOrderSummary;

                                  if (!posOrders || posOrders.length === 0) {
                                    return <div style={{ padding: "10px", color: "#888", textAlign: "center" }}>No Record Found</div>;
                                  }

                                  return posOrders.map((r, i) => {
                                    // Here you can add your orderType styles and render as you need
                                    let backgroundColor = "";
                                    let color = "";
                                    let padding = "";

                                    if (r.ordType === "DELIVERY") {
                                      backgroundColor = "rgb(194 199 253)";
                                      color = "rgb(13 38 113)";
                                      padding = "4px 21px 4px 12px";
                                    } else if (r.ordType === "DINEIN") {
                                      backgroundColor = "#f5cdcd";
                                      color = "#c50909";
                                      padding = "4px 30px 4px 12px";
                                    } else if (r.ordType === "TAKEAWAY") {
                                      backgroundColor = "rgb(200 231 204)";
                                      color = "rgb(47 155 61)";
                                      padding = "4px 3px 4px 8px";
                                    }

                                    return (
                                      <div
                                        key={i}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          color,
                                          paddingInline: "0 10px",
                                          border: "solid 1px #bbb9b9",
                                          backgroundColor: " rgb(225, 223, 223)",
                                          borderRadius: "5px",
                                          margin: "9px 0",
                                        }}
                                      >
                                        <span style={{ borderRadius: "4px 0 0 4px", padding, backgroundColor, color, border: "solid 1px #cfc9c9" }}>
                                          {r.ordType}
                                        </span>
                                        <span style={{ padding: "4px", color: "black" }}>{r.amtTotal}</span>
                                      </div>
                                    );
                                  });
                                })()}

                              </>)}

                            {showUpArrow && shiftStatus?.isDenomination === true && (
                              <div>
                                {entries.map((entry, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "8px",
                                      margin: "9px 0",
                                      border: "1px solid #bbb9b9",
                                      borderRadius: "5px",
                                      backgroundColor: "#e1dfdf",
                                    }}
                                  >
                                    <input
                                      type="number"
                                      placeholder="currency"
                                      value={entry.currency}
                                      onChange={(e) => handleChange(index, "currency", e.target.value)}
                                      style={{
                                        padding: "6px",
                                        width: "35%",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                      }}
                                    />
                                    <input
                                      type="number"
                                      placeholder="Count"
                                      value={entry.count}
                                      onChange={(e) => handleChange(index, "count", e.target.value)}
                                      style={{
                                        padding: "6px",
                                        width: "35%",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                      }}
                                    />
                                    <button
                                      onClick={() => deleteEntry(index)}
                                      style={{
                                        marginLeft: "8px",
                                        backgroundColor: "#ff4d4d",
                                        border: "none",
                                        color: "white",
                                        padding: "5px 8px",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      X
                                    </button>
                                  </div>
                                ))}
                                <div style={{ textAlign: "center" }}>
                                  <button
                                    onClick={addEntry}
                                    style={{
                                      padding: "6px 12px",
                                      backgroundColor: "#14008C",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "5px",
                                      fontWeight: "bold",
                                      cursor: "pointer",
                                    }}
                                  >
                                    + Row
                                  </button>
                                </div>
                              </div>)}

                            {/* Submit Button */}
                            <div style={{ textAlign: "center", marginTop: "20px" }}>
                              {!showUpArrow && (
                                <button className="btn btn-primary" style={{ backgroundColor: "#14008C", width: "50%", color: "white", fontWeight: "bold" }} onClick={() => (setShiftEndPasswordDialog(true), setDenominationDialog(false))}>
                                  Submit
                                </button>)}
                              {showUpArrow && (
                                <button className="btn btn-primary" style={{ backgroundColor: "#14008C", width: "50%", color: "white", fontWeight: "bold" }} onClick={handleAddSubmit}>
                                  ADD
                                </button>)}
                            </div>
                          </div>
                        </div>
                      </div>

                    )}

                    {/* <Dialog
                  open={denominationDialog}
                  maxWidth="lg"
                  onKeyDown={(e) =>
                    e.key === "Escape" && setDenominationDialog(false)
                  }
                >
                  <div className="shift-add-denomination-dialog">
                    <h4>Add Denomination</h4>
                    <div className="add-denomination-input-container-table">
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <div className="global-single-input">
                                <p>Currency</p>
                                <Select
                                  value={shiftDenominationBody.currency}
                                  onChange={shiftDenominationGetForm(
                                    "currency"
                                  )}
                                >
                                  <MenuItem value="Rs">Rs</MenuItem>
                                  <MenuItem value="dollar">$</MenuItem>
                                  <MenuItem value="SAR">SAR</MenuItem>
                                </Select>
                              </div>
                            </th>
                            <th>
                              <div className="global-single-input">
                                <p>Amount</p>
                                <input
                                  type="number"
                                  value={shiftDenominationBody.amount}
                                  onChange={shiftDenominationGetForm("amount")}
                                  placeholder="0"
                                />
                              </div>
                            </th>
                            <th>
                              <div className="global-single-input">
                                <p>Count</p>
                                <input
                                  type="number"
                                  value={shiftDenominationBody.count}
                                  onChange={shiftDenominationGetForm("count")}
                                  placeholder="0"
                                />
                              </div>
                            </th>
                            <th>
                              <div className="global-single-input">
                                <p>Total</p>
                                <input
                                  type="number"
                                  value={shiftDenominationBody.total}
                                  disabled
                                />
                              </div>
                            </th>
                            <th>
                              <button
                                className="shift-single-add-btn"
                                onClick={clickAddSingleDenomination}
                              >
                                +
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {shiftDenominationTable.length !== 0 ? (
                            shiftDenominationTable.map((r, i) => (
                              <tr key={i}>
                                <td style={{ width: "15%" }}>
                                  {r?.currency.toUpperCase()}
                                </td>
                                <td>{r?.amount}</td>
                                <td>{r?.count}</td>
                                <td>{r?.total}</td>
                                <td
                                  style={{
                                    border: "none",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <IconButton
                                    onClick={clickEditSingleDenomination(i)}
                                  >
                                    <i className="bi bi-pencil-square edit-icon"></i>
                                  </IconButton>
                                  <IconButton
                                    onClick={clickDelSingleDenomination(i)}
                                  >
                                    <i className="bi bi-trash3 delete-icon"></i>
                                  </IconButton>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colspan={5}
                                style={{
                                  backgroundColor: "#eee",
                                  border: "none",
                                }}
                              >
                                Empty
                              </td>
                            </tr>
                          )}
                          {shiftDenominationTable.length !== 0 && (
                            <tr>
                              <td style={{ border: "none" }}>&nbsp;</td>
                              <td style={{ border: "none" }}>&nbsp;</td>
                              <td
                                style={{ fontSize: "1rem", fontWeight: "700" }}
                              >
                                Grand Total
                              </td>
                              <td>{denominationGrandTotal}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="denomination-btn-container">
                      <button
                        onClick={() => setDenominationDialog(false)}
                        className="btn btn-secondary-outlined denomination-btn"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={denominationSubmitBtn}
                        className="btn btn-primary denomination-btn"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Dialog> */}

                    <Dialog
                      open={shiftReoprtOpen}
                      onClose={() => {
                        setShiftReportBtn(false)
                        dispatch(set_shift_report_branch(null))
                        dispatch(set_shift_report_shift(null))
                      }}
                      maxWidth='xl'
                      fullWidth
                    >
                      <ShiftReportTable />
                    </Dialog>
                    <CashInOrOut />
                  </div>
                </Toolbar>
                {billingScreen && (
                  <div
                    onClick={() => setBillingHeaderCollapsed(prev => !prev)}
                    style={{
                      position: 'absolute',
                      bottom: -14,
                      right: 8,
                      width: 28,
                      height: 14,
                      backgroundColor: '#e0e0e0',
                      borderRadius: '0 0 6px 6px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      zIndex: 13,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                    }}
                  >
                    <i
                      className={`bi bi-chevron-${billingHeaderCollapsed ? 'down' : 'up'}`}
                      style={{ fontSize: 10, color: '#555' }}
                    />
                  </div>
                )}
              </AppBar>
              <Drawer
                variant="permanent"
                open={false}
                className="drawer"
                style={{
                  overflow: "hidden",
                  height: "100vh",
                  display: billingScreen && "none",
                }}
              >
                <SideMenuUpdated />
              </Drawer>
            </>
          }
          <Box
            component="main"
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === "light"
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              flexGrow: 1,
              height: "100vh",
              overflow: billingScreen ? "hidden" : "auto",
            }}
          >
            {localStorage.getItem("portableMode") !== "active" && !billingScreen && <Toolbar />}
            {shouldShowOnboarding ? (
              renderSetupEmptyState()
            ) : selfUser ? (
              <Routes>
                <Route path="selfOrder" element={<SelfOrderScreen />}></Route>
              </Routes>
            ) : localStorage.getItem("portableMode") === "active" ? (
              <Routes>
                <Route path="portable" element={<PortableScreen />}></Route>
              </Routes>
            ) : (
              <Routes>
                {/* Main Admin Dashboard */}
                <Route path="dashboardhome" element={<DashboardHomeEntry />}></Route>
                <Route
                  path="crm/dashboard"
                  element={
                    <ProtectedRoute
                      element={CRMDashboard}
                      isAuthenticated={permission?.crm?.all || permission?.crm?.dashboard}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="crm/campaigns"
                  element={
                    <ProtectedRoute
                      element={CampaignManagement}
                      isAuthenticated={permission?.crm?.all || permission?.crm?.campaigns}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route path="ecommerce/seller" element={<SellerEcommerceDashboard />} />
                <Route path="demo" element={<PrintDemo />} />
                <Route path="403" element={<AccessDenied />} />
                <Route
                  path="inventory/operation/inventoryAdjustment/createInventoryAdjustment"
                  element={<CreateInventoryAdjustment />}
                />
                <Route
                  path="inventory/operation/inventoryAdjustment"
                  element={<InventoryAdjustment />}
                />
                <Route path="inventory/operation/LandedCost" element={<LandedCost />} />
                <Route path="inventory/operation/PhysicalClosingEntry" element={<PhysicalClosingEntry />} />
                <Route
                  path="inventory/operation/internalTransfer/createInternalTransfer"
                  element={<CreateInternalTransfer />}
                />
                <Route
                  path="inventory/operation/branchTransfer/createTransfer"
                  element={<CreateBranchTransfer />}
                />
                <Route path="inventory/operation/stockMoves" element={<StockMoves />} />
                <Route path="inventory/operation/internalTransfer" element={<InternalTransfer />} />
                <Route path="inventory/operation/branchTransfer" element={<BranchTransfer />} />
                <Route path="inventory/operation/internalTransfer/create" element={<CreateInternalTransfer />} />
                <Route path="inventory/operation/branchTransfer/create" element={<CreateBranchTransfer />} />
                <Route path="inventory/operation/branchTransfer/singleView" element={<BranchReceipt />} />
                <Route path="inventory/operation/branchTransfer/createReceipt" element={<CreateBranchReceipt />} />
                <Route path="inventory/operation/inventoryAdjustment/create" element={<CreateInventoryAdjustment />} />
                <Route
                  path="productList"
                  element={
                    <ProtectedRoute
                      element={ProductList}
                      isAuthenticated={permission?.products}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="productList/singleview"
                  element={
                    <ProtectedRoute
                      element={ProductListSingleView}
                      isAuthenticated={permission?.products}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                {/* Purchase Manager Section  */}
                <Route
                  path="purchaseManager/RequestForQuatation"
                  element={
                    <ProtectedRoute
                      element={RequestForQuatation}
                      isAuthenticated={permission?.purchase?.rfq}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchaseManager/RequestForQuatation/singleView"
                  element={
                    <ProtectedRoute
                      element={RequestForQuatationSingleView}
                      isAuthenticated={permission?.purchase?.rfq}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchaseManager/CreateRequestForQuatation"
                  element={
                    <ProtectedRoute
                      element={CreateRequestForQuotation1}
                      isAuthenticated={permission?.purchase?.rfq}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchaseManager/NewPurchaseOrder"
                  element={
                    <ProtectedRoute
                      element={NewPurchaseOrder}
                      isAuthenticated={permission?.purchase?.purchaseOrder}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchaseManager/CreateNewPurchaseOrder"
                  element={
                    <ProtectedRoute
                      element={CreateNewPurchaseOrder1}
                      isAuthenticated={permission?.purchase?.purchaseOrder}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchaseManager/PurchaseOrder/singleView"
                  element={
                    <ProtectedRoute
                      element={PurchaseOrderSingleView}
                      isAuthenticated={permission?.purchase?.purchaseOrder}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchaseManager/GoodsReceivedNote"
                  element={
                    <ProtectedRoute
                      element={GrnListing1}
                      isAuthenticated={permission?.purchase?.grn}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchaseManager/GoodsReceivedNote/SingleView"
                  element={
                    <ProtectedRoute
                      element={GoodsReceivedNotesSingleView}
                      isAuthenticated={permission?.purchase?.grn}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchaseManager/GoodsReceivedNote/add"
                  element={<NewGoodsReceivedNotes1 />}
                />
                <Route
                  path="purchasemanager/unitOfMeasurment"
                  element={
                    <ProtectedRoute
                      element={UnitOfMeasurment}
                      isAuthenticated={permission?.purchase?.uom}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchasemanager/newUnit"
                  element={
                    <ProtectedRoute
                      element={NewUOM}
                      isAuthenticated={permission?.purchase?.uom}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />

                <Route
                  path="purchasemanager/PurchaseReport/PurchaseReportNew"
                  element={
                    <ProtectedRoute
                      element={PurchaseReportNew}
                      isAuthenticated={permission?.purchase?.purchaseReport}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchasemanager/PurchaseReport/PurchaseReportNew/SingleView"
                  element={<PurchaseReportSingleView />}
                />


                <Route
                  path="purchaseManager/vendor/vendors"
                  element={
                    <ProtectedRoute
                      element={VendorListPurchaseManage}
                      isAuthenticated={permission?.purchase?.vendors}
                      fallbackPath="/userdashboard/403"
                    />
                  }
                />
                <Route
                  path="purchaseManager/vendor/Createvendors"
                  element={
                    <ProtectedRoute
                      element={SalesCustomers}
                      isAuthenticated={permission?.purchase?.vendors}
                      fallbackPath="/userdashboard/403"
                      isVendor={true}
                      isCustomer={false}
                      isSales={false}
                      isPurchase={true}
                    />
                  }
                />
                <Route
                  path="purchaseManager/vendor/Createvendors1"
                  element={<CreateVendors />}
                />

                {/* Transfer */}

                  <Route
                    path="purchaseManager/configuration"
                    element={
                      <ProtectedRoute
                        element={ConfigurationPurchase}
                        isAuthenticated={permission?.purchase?.configuration}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  {/* Orders section */}

                  {/* sales section */}
                  <Route path="pos/billingnew" element={
                    <ProtectedRoute
                      element={BillingNew}
                      isAuthenticated={permission?.pointOfSales?.billing}
                      fallbackPath="/userdashboard/403"
                    />

                  } />
                  <Route path="pos/specialItems" element={
                    <ProtectedRoute
                      element={SpecialItems}
                      isAuthenticated={permission?.pointOfSales?.specialItems}
                      fallbackPath="/userdashboard/403"
                    />

                  } />
                  <Route
                    path="pos/specialItems/create"
                    element={
                      <ProtectedRoute
                        element={CreateSpecialItems}
                        isAuthenticated={permission?.pointOfSales?.specialItems}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route path="sales/billingnew" element={<BillingNew />} />


                  {/* food management */}
                  <Route path="foodManagement/configuration"
                    element={
                      <ProtectedRoute
                        element={ConfigurationFood}
                        isAuthenticated={permission?.foodManagement?.configuration}
                        fallbackPath="/userdashboard/403"
                      />
                    } />

                  <Route path="foodManagement/recipe/costAnalysis" element={<RecipeCostAnalysis />} />
                  <Route path="foodManagement/recipe"
                    element={
                      <ProtectedRoute
                        element={RecipeFoodList}
                        isAuthenticated={permission?.foodManagement?.recipe}
                        fallbackPath="/userdashboard/403"
                      />

                    } />
                  <Route path="foodManagement/recipe/create" element={
                    <ProtectedRoute
                      element={RecipeFood}
                      isAuthenticated={permission?.foodManagement?.recipe}
                      fallbackPath="/userdashboard/403"
                    />

                  } />

                  <Route path="foodManagement/preperation"
                    element={
                      <ProtectedRoute
                        element={ManufacturingOrderList}
                        isAuthenticated={permission?.foodManagement?.preperation}
                        fallbackPath="/userdashboard/403"
                      />

                    } />
                  <Route path="foodManagement/manufacturingOrder/create" element={
                    <ProtectedRoute
                      element={ManufacturingOrder}
                      isAuthenticated={permission?.foodManagement?.preperation}
                      fallbackPath="/userdashboard/403"
                    />
                  } />
                  <Route path="foodManagement/manufacturingOrder/costAnalysis" element={<ManufacturingCostAnalysis />} />

                  {/* payroll section */}
                  {/* New Payroll Routes (Added Oct 30, 2025) */}
                  <Route path="payroll/dashboard" element={<PayrollDashboard />} />
                  <Route path="payroll/setup-wizard" element={<PayrollSetupWizard />} />
                  <Route path="payroll/compute-payslip" element={<ComputePayslip />} />
                  <Route path="payroll/payslips" element={<PayslipList />} />
                  <Route path="payroll/compute-batch" element={<ComputeBatchPayslip />} />
                  {/* Existing Payroll Routes */}
                  <Route path="payroll/paySlip" element={<Payslip />} />
                  <Route path="payroll/paySlip/create" element={<CreatePayslip />} />
                  <Route path="payroll/batchPayslip" element={<BatchPayslip />} />
                  <Route path="payroll/batchPayslip/create" element={<CreateBatchPayslip />} />
                  <Route path="payroll/salaryDisbursement" element={<SalaryDisbursement />} />
                  <Route path="payroll/salaryDisbursement/create" element={<CreateSalaryDisbursement />} />
                  <Route path="payroll/contractPayslip" element={<ContractPayslip />} />
                  <Route path="payroll/contractPayslip/create" element={<CreateContractPayslip />} />
                  <Route path="payroll/SponsorPayslip" element={<SponsorPayslip />} />
                  <Route path="payroll/SponsorPayslip/create" element={<CreateSponsorPayslip />} />
                  <Route path="payroll/loan/loanPayroll" element={<LoanPayroll />} />
                  <Route path="payroll/loan/loanPayroll/create" element={<CreateLoanPayroll />} />
                  <Route path="payroll/loan/loanEligibility" element={<LoanEligibility />} />
                  <Route path="payroll/loan/loanEligibility/create" element={<CreateLoanEligibility />} />
                  <Route path="payroll/attendance/attendancePayroll" element={<AttendancePayroll />} />
                  <Route path="payroll/attendance/settings" element={<AttendanceSettings />} />
                  <Route path="payroll/attendance/EossPayroll" element={<EossPayroll />} />
                  <Route path="payroll/attendance/EossPayroll/create" element={<CreateEoss />} />
                  <Route path="payroll/attendance/EossPayroll/:id" element={<CreateEoss />} />
                  <Route path="payroll/attendance/PayrollLeave" element={<PayrollLeave />} />
                  <Route path="payroll/attendance/PayrollLeave/create" element={<CreatePayrollLeave />} />
                  <Route path="payroll/attendance/LeaveBalance" element={<LeaveBalance />} />
                  <Route path="payroll/attendance/LeaveType" element={<LeaveType />} />
                  <Route path="payroll/attendance/OvertimePayroll" element={<OvertimePayroll />} />
                  <Route path="payroll/attendance/OvertimePayroll/create" element={<CreateOvertimePayroll />} />
                  <Route path="payroll/configuration/PayrollPayHead" element={<PayrollPayHead />} />
                  <Route path="payroll/configuration/PayrollPayHead/create" element={<CreatePayHead />} />
                  <Route path="payroll/configuration/PayOthersPayroll" element={<PayOthersPayroll />} />
                  <Route path="payroll/configuration/PayOthersPayroll/create" element={<CreatePayOthers />} />
                  <Route path="payroll/configuration/PayTemplatePayroll" element={<PayTemplatePayroll />} />
                  <Route path="payroll/configuration/PayTemplatePayroll/create" element={<CreatePaytemplate />} />
                  <Route path="payroll/configuration/PayrollSettings" element={<PayrollSettings />} />

                  <Route path="payroll/variableAndRecurring/allowance/variable" element={<VariableAllowance />} />
                  <Route path="payroll/variableAndRecurring/allowance/variable/create" element={<CreateVariableAllowance />} />
                  <Route path="payroll/variableAndRecurring/allowance/recurring" element={<RecurringAllowance />} />
                  <Route path="payroll/variableAndRecurring/allowance/recurring/create" element={<CreateRecurringAllowance />} />
                  <Route path="payroll/variableAndRecurring/deduction/variable" element={<VariableDeduction />} />
                  <Route path="payroll/variableAndRecurring/deduction/variable/create" element={<CreateVariableDeduction />} />
                  <Route path="payroll/variableAndRecurring/deduction/recurring" element={<RecurringDeduction />} />
                  <Route path="payroll/variableAndRecurring/deduction/recurring/create" element={<CreateRecurringDeduction />} />



                  {/* expense section */}
                  <Route path="Expense/staffExpense" element={
                    <ProtectedRoute
                      element={StaffExpense}
                      isAuthenticated={permission?.pointOfSales?.expense?.staffExpense}
                      fallbackPath="/userdashboard/403"
                    />


                  } />
                  <Route path="expense/outletExpense" element={
                    <ProtectedRoute
                      element={OutletExpense}
                      isAuthenticated={permission?.pointOfSales?.expense?.outletExpense}
                      fallbackPath="/userdashboard/403"
                    />

                  } />
                  <Route
                    path="expense/pettyCashReceipt"
                    element={
                      <ProtectedRoute
                        element={PettyCashReceipt}
                        isAuthenticated={userRole === "admin"}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="expense/addExpenseType"
                    element={
                      <ProtectedRoute
                        element={AddExpenseType}
                        isAuthenticated={permission?.pointOfSales?.expense?.addExpenseType}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  {/* Report section */}
                  <Route
                    path="report/posSalesReport"
                    element={<PosSalesReport />}
                  />
                  <Route path="report/stockReport" element={
                    <ProtectedRoute
                      element={StockReport}
                      isAuthenticated={permission?.report?.stockreport}
                      fallbackPath="/userdashboard/403"
                    />

                  } />
                  <Route
                    path="report/stockSummaryReport"
                    element={<StockSummaryReport />}
                  />

                  <Route
                    path="report/stockAdjustmentReport"
                    element={<StockAdjustmentReport />}
                  />
                  <Route path="report/expenseReport" element={
                    <ProtectedRoute
                      element={ExpenseReport}
                      isAuthenticated={permission?.report?.expenseReport}
                      fallbackPath="/userdashboard/403"
                    />

                  } />
                  {/* staff section */}

                  <Route path="staff/dashboard" element={<StaffDashboard />} />
                  <Route
                    path="staff/hrm/manageEmployee/viewEmployee/viewEmpTotalCommission"
                    element={<EmpDashboardTotalCommission />}
                  />

                  <Route path="staff/attendance" element={<StaffAttendance />} />

                  <Route
                    path="staff/leave/leaveApplication"
                    element={<StaffLeaveApplication />}
                  />
                  <Route path="staff/leave/holiday" element={<StaffHoliday />} />
                  <Route
                    path="staff/leave/addLeaveType"
                    element={<StaffAddLeaveType />}
                  />


                  <Route
                    path="staff/payroll/employeeSalary"
                    element={<StaffPayrollEmpSalary />}
                  />
                  <Route
                    path="staff/payroll/addPayRoll"
                    element={<StaffPayrollAddPayroll />}
                  />
                  <Route
                    path="staff/payroll/payRollItem"
                    element={<StaffPayrollItem />}
                  />
                  <Route path="staff/payroll/payslip" element={<StaffPaySlip />} />

                  <Route
                    path="staff/loan/addNewLoan"
                    element={<StaffAddNewLoan />}
                  />
                  <Route
                    path="staff/loan/loanReport"
                    element={<StaffLoanReport />}
                  />
                  <Route
                    path="staff/loan/loanApprovals"
                    element={<StaffLoanApprovals />}
                  />

                  <Route path="staff/hrm/dashboard" element={<HRMDashboard />} />

                  <Route path="staff/hrm/department" element={
                    <ProtectedRoute
                      element={Department}
                      isAuthenticated={permission?.staff?.hrm?.department}
                      fallbackPath="/userdashboard/403"
                    />

                  } />
                  <Route path="staff/hrm/designation" element={
                    <ProtectedRoute
                      element={Designation}
                      isAuthenticated={permission?.staff?.hrm?.designation}
                      fallbackPath="/userdashboard/403"
                    />

                  } />
                  <Route
                    path="staff/hrm/manageEmployee"
                    element={
                      <ProtectedRoute
                        element={ManageEmployee}
                        isAuthenticated={permission?.staff?.hrm?.manageEmployee}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="staff/hrm/manageEmployee/viewEmployee"
                    element={<ViewEmployee />}
                  />

                  <Route path="staff/hrm/addEmployee" element={
                    <ProtectedRoute
                      element={AddEmployee}
                      isAuthenticated={permission?.staff?.hrm?.addEmployee}
                      fallbackPath="/userdashboard/403"
                    />

                  } />
                  <Route path="staff/hrm/addDocument" element={
                    <ProtectedRoute
                      element={AddDocument}
                      isAuthenticated={permission?.staff?.hrm?.addDocument}
                      fallbackPath="/userdashboard/403"
                    />
                  } />
                  <Route
                    path="staff/hrm/addDocument/documentprint"
                    element={<DocumentPrintView />}
                  />

                  {/* Employee Transition & Performance Management System - Added Nov 2024 */}
                  {/* Transition Management */}
                  <Route 
                    path="staff/hrm/transitions" 
                    element={<EmployeeTransitionList />} 
                  />
                  <Route 
                    path="staff/hrm/transitions/create" 
                    element={<TransitionCreateForm />} 
                  />
                  <Route 
                    path="staff/hrm/transitions/edit/:id" 
                    element={<TransitionCreateForm />} 
                  />
                  
                  {/* Employee Tasks */}
                  <Route 
                    path="staff/hrm/tasks" 
                    element={<EmployeeTasks />} 
                  />

                  {/* Alternative HR paths for employee transition */}
                  <Route 
                    path="hr/employee-transition" 
                    element={<EmployeeTransitionList />} 
                  />
                  <Route 
                    path="hr/employee-transition/create" 
                    element={<TransitionCreateForm />} 
                  />
                  <Route 
                    path="hr/employee-transition/edit/:id" 
                    element={<TransitionCreateForm />} 
                  />

                  {/* Performance Management */}
                  <Route 
                    path="staff/hrm/performance/dashboard" 
                    element={<PerformanceDashboard />} 
                  />
                  <Route 
                    path="staff/hrm/performance/kpi" 
                    element={<KPIManagement />} 
                  />
                  <Route 
                    path="staff/hrm/performance/review/create" 
                    element={<PerformanceReviewForm />} 
                  />
                  <Route 
                    path="staff/hrm/performance/review/list" 
                    element={<PerformanceReviewList />} 
                  />
                  <Route 
                    path="staff/hrm/performance/pip" 
                    element={<PIPManagement />} 
                  />
                  <Route 
                    path="staff/hrm/performance/pip/create" 
                    element={<PIPCreateForm />} 
                  />
                  <Route 
                    path="staff/hrm/performance/goals" 
                    element={<GoalManagement />} 
                  />
                  <Route 
                    path="staff/hrm/performance/goals/create" 
                    element={<GoalForm />} 
                  />
                  <Route 
                    path="staff/hrm/performance/goals/edit/:id" 
                    element={<GoalForm />} 
                  />
                  <Route 
                    path="staff/hrm/performance/feedback360/:reviewId" 
                    element={<Feedback360Form />} 
                  />

                  {/* Asset Management */}
                  <Route 
                    path="staff/hrm/assets" 
                    element={<AssetList />} 
                  />
                  <Route 
                    path="staff/hrm/assets/create" 
                    element={<AssetForm />} 
                  />
                  <Route 
                    path="staff/hrm/assets/view/:id" 
                    element={<AssetDetailsView />} 
                  />
                  <Route 
                    path="staff/hrm/assets/edit/:id" 
                    element={<AssetForm />} 
                  />
                  <Route 
                    path="staff/hrm/assets/bulk-assign" 
                    element={<BulkAssetAssignment />} 
                  />
                  <Route 
                    path="staff/hrm/assets/reports" 
                    element={<AssetReports />} 
                  />

                  {/* Notifications */}
                  <Route 
                    path="staff/hrm/notifications" 
                    element={<NotificationCenter />} 
                  />
                  <Route 
                    path="staff/hrm/notifications/preferences" 
                    element={<NotificationPreferences />} 
                  />
                  <Route 
                    path="staff/hrm/notifications/push-setup" 
                    element={<PushNotificationSetup />} 
                  />
                  <Route 
                    path="staff/hrm/notifications/settings" 
                    element={<NotificationSettings />} 
                  />
                  <Route 
                    path="staff/hrm/notifications/audit-logs" 
                    element={<AuditLogs />} 
                  />
                  <Route 
                    path="system/rbac-management" 
                    element={<RBACManagement />} 
                  />
                  <Route 
                    path="system/rbac-diagnostics" 
                    element={<RBACDiagnostics />} 
                  />
                  <Route 
                    path="system/roles-permissions" 
                    element={<RolesAndPermissionNew />} 
                  />

                  {/* Device Settings */}

                  <Route path="Devicesettings" element={<DeviceSettings />} />

                  {/* settings section */}
                  <Route path="settings" element={<Settings />} />


                  <Route path="qr/barcode" element={<GenerateQrOrBarcode />} />

                  {/* account section */}
                  {/* customers */}

                  <Route
                    path="accounts/"
                    element={
                      <ProtectedRoute
                        element={AccountDashboard}
                        isAuthenticated={permission?.accounts?.dashboard}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="accounts/configuration"
                    element={
                      <ProtectedRoute
                        element={Configuration}
                        isAuthenticated={permission?.accounts?.configuration}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="accounts/customers/customerInvoices"
                    element={
                      <ProtectedRoute
                        element={CustomerInvoice}
                        isAuthenticated={permission?.accounts?.customers?.customerInvoice}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  <Route
                    path="accounts/customers/customerInvoices/singleView"
                    element={
                      <ProtectedRoute
                        element={CustomerInvoiceSingleView}
                        isAuthenticated={permission?.accounts?.customers?.customerInvoice}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="accounts/customers/customerInvoices/create"
                    element={
                      <ProtectedRoute
                        element={CreateCustomerInvoice}
                        isAuthenticated={permission?.accounts?.customers?.customerInvoice}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/customers/saleswso"
                    element={
                      <ProtectedRoute
                        element={SalesWSO}
                        isAuthenticated={permission?.accounts?.customers?.saleswoso}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="accounts/customers/saleswso/create"
                    element={
                      <ProtectedRoute
                        element={CreateSalesWSO}
                        isAuthenticated={permission?.accounts?.customers?.saleswoso}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/customers/saleswso/singleView"
                    element={
                      <ProtectedRoute
                        element={SalesWSOsingleView}
                        isAuthenticated={permission?.accounts?.customers?.saleswoso}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/customer/payments"
                    element={
                      <ProtectedRoute
                        element={CustomerPayments}
                        isAuthenticated={permission?.accounts?.customers?.payments}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="accounts/customer/payments/create"
                    element={
                      <ProtectedRoute
                        element={CreateCustomerPayment}
                        isAuthenticated={permission?.accounts?.customers?.payments}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/customers/creditNotes"
                    element={
                      <ProtectedRoute
                        element={CustomerCreditNotes}
                        isAuthenticated={permission?.accounts?.customers?.creditNotes}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="accounts/customers/creditNotes/SingleView"
                    element={
                      <ProtectedRoute
                        element={CreaditNoteSingleView}
                        isAuthenticated={permission?.accounts?.customers?.creditNotes}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/customers/creditNotes/create"
                    element={
                      <ProtectedRoute
                        element={CreateCustomerCreditNotes}
                        isAuthenticated={permission?.accounts?.customers?.creditNotes}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  {/* <Route
                path="accounts/customers/customers"
                element={<Vendors />}
              /> */}

                  <Route
                    path="accounts/customers/customers"
                    element={
                      <ProtectedRoute
                        element={Customers}
                        isAuthenticated={permission?.accounts?.customers?.customers}
                        fallbackPath="/userdashboard/403"
                        isSales={false}
                      />
                      // <Customers isSales={false} />
                    }
                  />

                  <Route
                    path="accounts/customers/customers/create"
                    element={
                      <ProtectedRoute
                        element={SalesCustomers}
                        isAuthenticated={permission?.accounts?.customers?.customers}
                        fallbackPath="/userdashboard/403"
                        isCustomer={true}
                        isVendor={false}
                        isSales={false}
                        isPurchase={false}
                      />

                    }
                  />

                  <Route
                    path="accounts/customers/customers/create1"
                    element={<CreateCustomer />}
                  />
                  <Route
                    path="accounts/Reconciliation/BankReconciliation"
                    element={
                      <ProtectedRoute
                        element={BankReconciliationNew}
                        isAuthenticated={permission?.accounts?.reconcilation?.bankReconcilation}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  <Route
                    path="accounts/Reconciliation/BankReconciliation/Create"
                    element={
                      <ProtectedRoute
                        element={CreateBankReconciliation}
                        isAuthenticated={permission?.accounts?.reconcilation?.bankReconcilation}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/vatReport/inputOrOutputReport"
                    element={
                      <ProtectedRoute
                        element={InputOrOutputReport}
                        isAuthenticated={permission?.accounts?.vatreport?.inputoroutputreport}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  {/* accounting */}
                  <Route path="accounts/accounting/journal" element={
                    <ProtectedRoute
                      element={Journal}
                      isAuthenticated={permission?.accounts?.accounting?.journal}
                      fallbackPath="/userdashboard/403"
                    />

                  } />
                  <Route
                    path="accounts/accounting/journal/createjournal"
                    element={
                      <ProtectedRoute
                        element={CreateJournal}
                        isAuthenticated={permission?.accounts?.accounting?.journal}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/accounting/chartofaccounts"
                    element={
                      <ProtectedRoute
                        element={ChartOfAccounts}
                        isAuthenticated={permission?.accounts?.accounting?.chartofaccounts}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="accounts/accounting/createchartofaccounts"
                    element={
                      <ProtectedRoute
                        element={CreateChartOfAccount}
                        isAuthenticated={permission?.accounts?.accounting?.chartofaccounts}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/accounting/openingBalance"
                    element={
                      <ProtectedRoute
                        element={OpeningBalance}
                        isAuthenticated={permission?.accounts?.accounting?.openingBalance}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="accounts/accounting/openingBalance/create"
                    element={
                      <ProtectedRoute
                        element={CreateOpeningBalance}
                        isAuthenticated={permission?.accounts?.accounting?.openingBalance}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/accounting/journalEntries"
                    element={
                      <ProtectedRoute
                        element={JournalEntries}
                        isAuthenticated={permission?.accounts?.accounting?.journalEntries}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="accounts/accounting/journalEntriesCreate"
                    element={
                      <ProtectedRoute
                        element={JournalEntriesForm}
                        isAuthenticated={permission?.accounts?.accounting?.journalEntries}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/accounting/recurringposting"
                    element={<ReccurringPosting />}
                  />
                  {/* ACcounts vendor */}

                  <Route
                    path="accounts/vendor/vendorBills"
                    element={
                      <ProtectedRoute
                        element={VendorBills1}
                        isAuthenticated={permission?.accounts?.vendor?.vendorBills}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  <Route
                    path="accounts/vendor/SingleView"
                    element={
                      <ProtectedRoute
                        element={VendorBillSingleView}
                        isAuthenticated={permission?.accounts?.vendor?.vendorBills}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/vendor/createvendorBills"
                    element={
                      <ProtectedRoute
                        element={CreateVendorBills1}
                        isAuthenticated={permission?.accounts?.vendor?.vendorBills}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />



                  <Route
                    path="accounts/vendor/payments"
                    element={
                      <ProtectedRoute
                        element={VendorPayments}
                        isAuthenticated={permission?.accounts?.vendor?.payments}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="accounts/vendor/createvendorPayments"
                    element={
                      <ProtectedRoute
                        element={CreateVendorPayments}
                        isAuthenticated={permission?.accounts?.vendor?.payments}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/vendor/DebitNotes"
                    element={
                      <ProtectedRoute
                        element={DebitNotes}
                        isAuthenticated={permission?.accounts?.vendor?.debitNotes}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  <Route
                    path="accounts/vendor/DebitNotes/create"
                    element={
                      <ProtectedRoute
                        element={CreateDebitNote}
                        isAuthenticated={permission?.accounts?.vendor?.debitNotes}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/vendor/DebitNote/SingleView"
                    element={
                      <ProtectedRoute
                        element={DebitNoteSingleView}
                        isAuthenticated={permission?.accounts?.vendor?.debitNotes}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/vendor/vendors"
                    element={
                      <ProtectedRoute
                        element={Vendors}
                        isAuthenticated={permission?.accounts?.vendor?.vendors}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/vendor/Createvendors"
                    element={
                      <ProtectedRoute
                        element={SalesCustomers}
                        isAuthenticated={permission?.accounts?.vendor?.vendors}
                        fallbackPath="/userdashboard/403"
                        isVendor={true}
                        isCustomer={false}
                        isSales={false}
                        isPurchase={false}
                      />
                    }
                  />
                  <Route
                    path="accounts/vendor/Createvendors1"
                    element={<CreateVendors />}
                  />
                  <Route
                    path="purchaseManager/vendor/Createvendors"
                    element={
                      <ProtectedRoute
                        element={SalesCustomers}
                        isAuthenticated={permission?.purchase?.vendors}
                        fallbackPath="/userdashboard/403"
                        isVendor={true}
                        isCustomer={false}
                        isSales={false}
                        isPurchase={true}
                      />
                    }
                  />
                  <Route
                    path="purchaseManager/vendor/Createvendors1"
                    element={<CreateVendors />}
                  />
                  <Route
                    path="accounts/vendor/purchasewopo"
                    element={
                      <ProtectedRoute
                        element={PurchaseWOPO1}
                        isAuthenticated={permission?.accounts?.vendor?.purchasewpo}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  <Route
                    path="accounts/vendor/purchasewopo/create"
                    element={
                      <ProtectedRoute
                        element={CreatePurchaseWOPO1}
                        isAuthenticated={permission?.accounts?.vendor?.purchasewpo}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/vendor/purchasewopo/SingleView"
                    element={
                      <ProtectedRoute
                        element={PurchaseWOPOsingleView}
                        isAuthenticated={permission?.accounts?.vendor?.purchasewpo}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />



                  {/* Account Report*/}
                  <Route
                    path="accounts/report/financialReport/generalLedger"
                    element={
                      <ProtectedRoute
                        element={GeneralLedgerNw}
                        isAuthenticated={permission?.accounts?.report?.financialReport?.generalLedger}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/financialReport/trialbalance"
                    element={
                      <ProtectedRoute
                        element={TrialBalance}
                        isAuthenticated={permission?.accounts?.report?.financialReport?.trialBalance}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/financialReport/balancesheet"
                    element={
                      <ProtectedRoute
                        element={BalanceSheet}
                        isAuthenticated={permission?.accounts?.report?.financialReport?.balanceSheet}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/financialReport/Profit&Loss"
                    element={
                      <ProtectedRoute
                        element={ProfitAndLoss}
                        isAuthenticated={permission?.accounts?.report?.financialReport?.profitAndLoss}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="accounts/report/financialReport/GstrReport"
                    // element={<LedgerBalance />}
                    element={<GstrReport/>}
                  />
                  <Route
                    path="accounts/report/financialReport/trialbalance/ledgerBalance"
                    element={<LedgerBalance />}
                  />

                  {/* Partner Report */}
                  <Route
                    path="accounts/report/partnerReport/accountPayable"
                    element={
                      <ProtectedRoute
                        element={AccountPayable}
                        isAuthenticated={permission?.accounts?.report?.partnerReports?.accountPayable}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/partnerReport/accountPayable/singleView"
                    element={<AccountPayableSingleView />}
                  />
                  <Route
                    path="sales/Report/CustomerReceiptReport"
                    element={
                      <ProtectedRoute
                        element={CustomerReceiptReport}
                        isAuthenticated={permission?.accounts?.report?.generalReport?.customerReciept}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="sales/Report/CustomerReceiptReportSingleView"
                    element={<CustomerReceiptReportSingleView />}
                  />
                  <Route
                    path="accounts/report/partnerReport/accountReceivable"
                    element={
                      <ProtectedRoute
                        element={AccountRecievable}
                        isAuthenticated={permission?.accounts?.report?.partnerReports?.accountReceivable}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="accounts/report/partnerReport/accountReceivable/singleView"
                    element={<AccountRecievableSingleView />}
                  />
                  <Route
                    path="accounts/report/partnerReport/AccountReceivableAgingReport"
                    element={
                      <ProtectedRoute
                        element={AccountReceivableAgingReport}
                        isAuthenticated={permission?.accounts?.report?.partnerReports?.agingReportReceivable}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/partnerReport/AccountReceivableAgingReportSingleView"
                    element={<AccountReceivableAgingReportSingleView />}
                  />
                  <Route
                    path="accounts/report/partnerReport/AccountPayableAgingReport"
                    element={
                      <ProtectedRoute
                        element={AccountPayableAgingReport}
                        isAuthenticated={permission?.accounts?.report?.partnerReports?.agingReportPayable}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/partnerReport/AccountPayableAgingReportSingleView"
                    element={<AccountPayableAgingReportSingleView />}
                  />
                  <Route
                    path="accounts/report/partnerReport/ReceivableDueReport"
                    element={
                      <ProtectedRoute
                        element={ReceivableDueReport}
                        isAuthenticated={permission?.accounts?.report?.partnerReports?.receivableDueReport}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/partnerReport/ReceivableDueReport/SingleView"
                    element={<ReceivableDueReportSingleView />}
                  />
                  <Route
                    path="accounts/report/partnerReport/PayableDueReport"
                    element={
                      <ProtectedRoute
                        element={PyableDueReport}
                        isAuthenticated={permission?.accounts?.report?.partnerReports?.payableDueReport}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/partnerReport/PayableDueReport/SingleView"
                    element={<PayableDueReportSingleView />}
                  />

                  {/* General Report */}
                  <Route
                    path="accounts/report/generalReport/bankAndCashReport"
                    element={
                      <ProtectedRoute
                        element={BankAndCashReport}
                        isAuthenticated={permission?.accounts?.report?.generalReport?.bankAndCash}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/generalReport/bankAndCashReport/singleView"
                    element={<BankAndCashReportSingleView />}
                  />
                  <Route
                    path="accounts/report/generalReport/ChequeRegisterReport"
                    element={
                      <ProtectedRoute
                        element={ChequeRegisterReport}
                        isAuthenticated={permission?.accounts?.report?.generalReport?.chequeRegister}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/generalReport/InvoiceMarginReport"
                    element={
                      <ProtectedRoute
                        element={InvoiceMarginReport}
                        isAuthenticated={permission?.accounts?.report?.generalReport?.invoiceMargin}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/generalReport/InvoiceMarginReport/SingleView"
                    element={<InvoiceMarginReportSingleView />}
                  />
                  <Route
                    path="accounts/report/generalReport/productMarginReport"
                    element={
                      <ProtectedRoute
                        element={ProductMarginReport}
                        isAuthenticated={permission?.accounts?.report?.generalReport?.productMargin}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="accounts/report/generalReport/productMarginReport/SingleView"
                    element={<ProductMarginReportSingleView />}
                  />

                  {/* configuration */}

                  {/* inventory */}
                  <Route
                    path="inventory/configuration/warehouse"
                    element={
                      <ProtectedRoute
                        element={WareHouse}
                        isAuthenticated={permission?.inventory?.configuration?.warehouse}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/configuration/createwarehouse"
                    element={
                      <ProtectedRoute
                        element={CreateWareHouse}
                        isAuthenticated={permission?.inventory?.configuration?.warehouse}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="inventory/configuration/location"
                    element={
                      <ProtectedRoute
                        element={InventoryLocation}
                        isAuthenticated={permission?.inventory?.configuration?.location}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  <Route
                    path="inventory/configuration/location/create"
                    element={
                      <ProtectedRoute
                        element={CreateInvLocation}
                        isAuthenticated={permission?.inventory?.configuration?.location}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="inventory/configuration/settings"
                    element={
                      <ProtectedRoute
                        element={SettingsProductVariant}
                        isAuthenticated={permission?.inventory?.configuration?.settings}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/configuration/attribute"
                    element={
                      <ProtectedRoute
                        element={Attribute}
                        isAuthenticated={permission?.inventory?.configuration?.attribute}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/configuration/attribute/create"
                    element={
                      <ProtectedRoute
                        element={CreateAttribute}
                        isAuthenticated={permission?.inventory?.configuration?.attribute}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="inventory/configuration/poscategory"
                    element={
                      <ProtectedRoute
                        element={POSCategory}
                        isAuthenticated={permission?.inventory?.configuration?.poscategory}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/configuration/poscategory/create"
                    element={
                      <ProtectedRoute
                        element={CreatePOSCategory}
                        isAuthenticated={permission?.inventory?.configuration?.poscategory}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="inventory/configuration/category"
                    element={
                      <ProtectedRoute
                        element={Category}
                        isAuthenticated={permission?.inventory?.configuration?.category}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/configuration/category/create"
                    element={
                      <ProtectedRoute
                        element={CreateCategory}
                        isAuthenticated={permission?.inventory?.configuration?.category}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="inventory/reports/stockMove"
                    element={
                      <ProtectedRoute
                        element={StockMove}
                        isAuthenticated={permission?.inventory?.reports?.stockMoveReport}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/reports/stockMove/singleView"
                    element={<StockMoveSingleView />}
                  />


                  <Route
                    path="inventory/operation/Interanltransfer"
                    element={
                      <ProtectedRoute
                        element={InternalTransfer}
                        isAuthenticated={permission?.inventory?.operations?.internalTransfer}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/operation/InternalTransfer/create"
                    element={
                      <ProtectedRoute
                        element={CreateInternalTransfer}
                        isAuthenticated={permission?.inventory?.operations?.internalTransfer}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="inventory/operation/branchtransfer"
                    element={
                      <ProtectedRoute
                        element={BranchTransfer}
                        isAuthenticated={permission?.inventory?.operations?.branchTransfer}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/operation/branchtransfer/create"
                    element={
                      <ProtectedRoute
                        element={CreateBranchTransfer}
                        isAuthenticated={permission?.inventory?.operations?.branchTransfer}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="inventory/operation/inventoryAdjustment"
                    element={
                      <ProtectedRoute
                        element={InventoryAdjustment}
                        isAuthenticated={permission?.inventory?.operations?.inventoryAdjustments}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/operation/inventoryAdjustment/create"
                    element={
                      <ProtectedRoute
                        element={CreateInventoryAdjustment}
                        isAuthenticated={permission?.inventory?.operations?.inventoryAdjustments}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/operation/physicalClosing"
                    element={<PhysicalClosingEntry />}
                  />
                  <Route
                    path="inventory/operation/landedcost"
                    element={<LandedCost />}
                  />
                  <Route
                    path="inventory/operation/landedcost/create"
                    element={<CreateLandedCost />}
                  />
                  <Route
                    path="inventory/operation/stockmoves"
                    element={
                      <ProtectedRoute
                        element={StockMoves}
                        isAuthenticated={permission?.inventory?.operations?.stockMoves}
                        fallbackPath="/userdashboard/403"
                      />}
                  />
                  <Route
                    path="/Inventory/Reports/IaReport"
                    element={<IaReport />}
                  />



                  <Route
                    path="inventory/operation/branchreceipt"
                    element={
                      <ProtectedRoute
                        element={BranchReceipt}
                        isAuthenticated={permission?.inventory?.operations?.branchReciept}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/operation/branchreceipt/create"
                    element={<CreateBranchReceipt />}
                  />

                  {/* inventory-operation-product */}

                  <Route
                    path="inventory/products/product"
                    element={
                      <ProtectedRoute
                        element={ProductListUpdated}
                        isAuthenticated={permission?.inventory?.products?.product}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/products/product/create"
                    element={
                      <ProtectedRoute
                        element={CreateProductList}
                        isAuthenticated={permission?.inventory?.products?.product}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="inventory/products/productmaster"
                    element={
                      <ProtectedRoute
                        element={ProductMasterUpdated}
                        isAuthenticated={permission?.inventory?.products?.productMaster}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="inventory/products/productmaster/create"
                    element={
                      <ProtectedRoute
                        element={CreateProductMaster}
                        isAuthenticated={permission?.inventory?.products?.productMaster}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  {/* sales new */}
                  <Route
                    path="sales/orders/quotation"
                    element={
                      <ProtectedRoute
                        element={SalesQuotation}
                        isAuthenticated={permission?.sales?.quotation}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="sales/orders/quotation/create"
                    element={
                      <ProtectedRoute
                        element={CreateSalesQuotation}
                        isAuthenticated={permission?.sales?.quotation}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="sales/orders/quotation/singleView"
                    element={
                      <ProtectedRoute
                        element={SalesQuatationSingleVieww}
                        isAuthenticated={permission?.sales?.quotation}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route path="sales/orders/salesOrder"
                    element={
                      <ProtectedRoute
                        element={SalesOrder}
                        isAuthenticated={permission?.sales?.salesOrder}
                        fallbackPath="/userdashboard/403"
                      />

                    } />
                  <Route
                    path="sales/orders/salesOrder/create"
                    element={
                      <ProtectedRoute
                        element={CreateSalesOrder}
                        isAuthenticated={permission?.sales?.salesOrder}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="sales/orders/salesOrder/singleView"
                    element={
                      <ProtectedRoute
                        element={SalesOrderSingleView}
                        isAuthenticated={permission?.sales?.salesOrder}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="sales/orders/deliveryNote"
                    element={
                      <ProtectedRoute
                        element={DeliveryNote}
                        isAuthenticated={permission?.sales?.deliveryNote}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  <Route
                    path="sales/orders/deliveryNote/SingleView"
                    element={
                      <ProtectedRoute
                        element={DeliverNoteSingleView}
                        isAuthenticated={permission?.sales?.deliveryNote}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="sales/orders/deliveryNote/create"
                    element={
                      <ProtectedRoute
                        element={CreateDeliiveryNote}
                        isAuthenticated={permission?.sales?.deliveryNote}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="sales/orders/customers"
                    element={
                      <ProtectedRoute
                        element={Customers}
                        isAuthenticated={permission?.sales?.customers}
                        fallbackPath="/userdashboard/403"
                        isSales={true}
                      />
                      // <Customers isSales={true} />
                    }
                  />
                  <Route
                    path="sales/orders/customers/create"
                    element={
                      <SalesCustomers
                        isCustomer={true}
                        isVendor={false}
                        isSales={true}
                        isPurchase={false}
                      />
                    }
                  />


                  <Route
                    path="sales/orders/pricelist/create"
                    element={<CreatePriceList />}
                  />
                  <Route path="sales/orders/pricelist" element={<PriceList />} />
                  <Route
                    path="sales/Report/salesReport"
                    element={
                      <ProtectedRoute
                        element={SalesNewReport}
                        isAuthenticated={permission?.sales?.report?.salesReport}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="sales/Report/salesReportSingleView"
                    element={<SalesReportSingleView />}
                  />
                  <Route
                    path="sales/Report/salesReportBySalesPerson"
                    element={
                      <ProtectedRoute
                        element={SalesReportBySalesPerson}
                        isAuthenticated={permission?.sales?.report?.salesReportBySalesPerson}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="sales/Report/salesReportBySalesSingleView"
                    element={<SalesReportBySalesSingleView />}
                  />

                  {/* point of sale */}
                  {/* configuration */}
                  <Route
                    path="pointOfSales/configuration/settings"
                    element={
                      <ProtectedRoute
                        element={PosSettings}
                        isAuthenticated={permission?.pointOfSales?.configuration?.settings}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="pointOfSales/configuration/BranchSettings"
                    element={
                      <ProtectedRoute
                        element={BranchSettings}
                        isAuthenticated={permission?.pointOfSales?.configuration?.branchSettings}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="pointOfSales/configuration/BranchSettings/create"
                    element={
                      <ProtectedRoute
                        element={BranchSettingsForm}
                        isAuthenticated={permission?.pointOfSales?.configuration?.branchSettings}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="pointOfSales/configuration/Aggregator"
                    element={
                      <ProtectedRoute
                        element={Aggregator}
                        isAuthenticated={permission?.pointOfSales?.configuration?.aggregator}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  {/* pos general */}
                  <Route
                    path="pointOfSales/general/shift"
                    element={
                      <ProtectedRoute
                        element={PosShift}
                        isAuthenticated={permission?.pointOfSales?.general?.shift}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="pointOfSales/general/shiftSingleView"
                    element={
                      <ProtectedRoute
                        element={PosShiftSingleView}
                        isAuthenticated={permission?.pointOfSales?.general?.shift}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="pointOfSales/general/orders"
                    element={
                      <ProtectedRoute
                        element={PosOrders}
                        isAuthenticated={permission?.pointOfSales?.general?.orders}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  <Route
                    path="pointOfSales/general/orderSingleView"
                    element={
                      <ProtectedRoute
                        element={PosOrdersSingleView}
                        isAuthenticated={permission?.pointOfSales?.general?.orders}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  <Route
                    path="pointOfSales/general/payments"
                    element={
                      <ProtectedRoute
                        element={PosPayment}
                        isAuthenticated={permission?.pointOfSales?.general?.payments}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="pointOfSales/general/wallet"
                    element={
                      <ProtectedRoute
                        element={PosWallet}
                        isAuthenticated={permission?.pointOfSales?.general?.wallet}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />

                  {/* {pos Report section} */}
                  <Route
                    path="pointOfSales/report/shiftReport"
                    element={
                      <ProtectedRoute
                        element={PosShiftReport}
                        isAuthenticated={permission?.pointOfSales?.report?.shiftReport}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="PointOfSales/report/shiftReportnew"
                    element={
                      <ProtectedRoute
                        element={PosNewShiftReport}
                        // isAuthenticated={permission?.PointOfSales?.report?.shiftReportNew}
                        isAuthenticated={true}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />
                  <Route
                    path="pointOfSales/report/shiftSummaryReport"
                    element={
                      <ProtectedRoute
                        element={PosShiftSummaryReport}
                        isAuthenticated={permission?.pointOfSales?.report?.shiftSummaryReport}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="pointOfSales/report/salesDetails"
                    element={
                      <ProtectedRoute
                        element={PosSalesDetails}
                        isAuthenticated={permission?.pointOfSales?.report?.salesDetails}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="pointOfSales/report/aggregatorReport"
                    element={
                      <ProtectedRoute
                        element={PosAggregatorReport}
                        isAuthenticated={permission?.pointOfSales?.report?.aggregatorReport}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="pointOfSales/report/DailyCashCardSummary"
                    element={
                      <ProtectedRoute
                        element={DailyCashCardSummary}
                        isAuthenticated={permission?.pointOfSales?.report?.cashcardSummary}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  <Route
                    path="pointOfSales/report/PosSalesSummery"
                    element={
                      <ProtectedRoute
                        element={PosSalesSummery}
                        isAuthenticated={permission?.pointOfSales?.report?.cashcardSummary}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />

                  <Route
                    path="timeSalesReport/timeSalesReport"
                    element={<TimeSalesReport />}
                  />

                  {/* payroll section */}
                  {/* <Route path="payroll/Establishment" element={<EstablisId />} />/
              <Route
                path="payroll/Attendance/Overtime"
                element={<OvertimeList />}
              />
              <Route
                path="payroll/configuration/payHead"
                element={<PayHead />}
              />
              <Route
                path="payroll/configuration/payHead"
                element={<PayHead />}
              /> */}
                  <Route path="invoiceView" element={<QrcodeScanView />} />
                  {/* floor management  */}
                  <Route path="floorManagement" element={
                    <ProtectedRoute
                      element={AddSeat}
                      isAuthenticated={permission?.pointOfSales?.floorManagement}
                      fallbackPath="/userdashboard/403"
                    />

                  } />

                  {/* kitchen order ticket  */}
                  <Route
                    path="kitchenOrderTicket"
                    element={
                      <ProtectedRoute
                        element={KitchenOrderTicket}
                        isAuthenticated={permission?.pointOfSales?.kot}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  {/* Delivery Counter screen  */}
                  <Route
                    path="deliveryCounter"
                    element={
                      <ProtectedRoute
                        element={DeliveryScreen}
                        isAuthenticated={true}
                        // isAuthenticated={permission?.pointOfSales?.kot}
                        fallbackPath="/userdashboard/403"
                      />

                    }
                  />
                  {/* kitchen order token display  */}
                  <Route
                    path="tokenDisplay"
                    element={
                      <ProtectedRoute
                        element={templatekot === 'classic' ? KotTokenDisplay : KotTokenDisplay2}
                        //  element={KotTokenDisplay}
                        isAuthenticated={permission?.pointOfSales?.tokenDisplay}
                        fallbackPath="/userdashboard/403"
                      />
                    }
                  />


                  {/* customer display  */}
                  <Route path="customerDisplay" element={
                    <ProtectedRoute
                      element={CustomerDisplay}
                      isAuthenticated={permission?.pointOfSales?.customerDisplay}
                      fallbackPath="/userdashboard/403"
                    />


                  } />

                  {/* test screen  */}
                  <Route path="testPage" element={<DeliveryScreen />} />
                  {/* pos print priveiw screen  */}
                  <Route path="posReaderPreview" element={<PosReaderPreview />} />

                  </Routes>
            )}
            {/* <Typography>home</Typography> */}

            {
              !selfUser &&
              <IconButton
                onClick={handleFullscreen}
                sx={{
                  position: "fixed",
                  bottom: "10px",
                  left: "10px",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
                  backgroundColor: "#fafafa",
                  zIndex: 11,
                }}
              >
                {
                  fullScreenEnable ?
                    <FullscreenExitIcon />
                    : <FullscreenIcon />
                }
              </IconButton>

            }
            {
              isMobile && !selfUser &&
              <IconButton
                onClick={logOutUser(
                  true,
                  userRole,
                  shiftBtnState,
                  shiftEndBtnClick
                )}
                sx={{
                  position: "absolute",
                  top: "93%",
                  left: "10px",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
                  backgroundColor: "#fafafa"
                }}
              >
                <PowerSettingsNewIcon
                  style={{ color: "red" }}
                />
              </IconButton>

            }
          </Box>
        </Box>
      </ThemeProvider>

      {showCheckOutPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-box-head" >
              <div style={{ placeSelf: "end" }}>
                <IconButton
                  onClick={() => {
                    setShowCheckOutPopup(false);
                    dispatch(
                      switch_to_billing_screen({ billingBoolean: false })
                    );
                    navigateTo('/userdashboard/dashboardhome');
                  }}
                >
                  <HighlightOffOutlinedIcon
                    sx={{
                      color: "white",
                      fontSize: "30px",
                      fontWeight: "400",
                    }}
                  />
                </IconButton>
              </div>
              {(() => {
                const imgUrl = resolveEmpImage(selectedCheckoutEmployee);
                return imgUrl ? (
                  <CachedImage src={imgUrl} alt="emp" style={{ borderRadius: "30px", height: "7vh", width: "7vh", marginTop: "-31px" }} fallbackStyle={{ borderRadius: "30px", height: "7vh", width: "7vh", marginTop: "-31px", background: "#ddd" }} />
                ) : (
                  <ColoredAvatar emp={selectedCheckoutEmployee} size={Math.max(40, window.innerHeight * 0.07)} circle={false} />
                );
              })()}
            </div>
            <div style={{ paddingBottom: "11px" }}>
              <p style={{ color: "gray" }}>Employee</p>
              <p>{selectedCheckoutEmployee?.staff_name || selectedCheckoutEmployee?.name || userInfo?.userName}</p>
              <button className="btn btn-primary" style={{ height: "33px", width: "37%" }} onClick={() => { setShowSecondCheckOutPopup(true); setShowCheckOutPopup(false); }}>Check Out</button>
            </div>
          </div>
        </div>
      )}
      {showSecondCheckOutPopup && (
        <div className="popup-overlay">
          <div className="popup-box" style={{ width: "295px" }}>
            <div className="popup-box-head" style={{ display: "flex", justifyContent: "space-between", height: "5vh", paddingInline: "3px" }}>
              {(() => {
                const imgUrl = resolveEmpImage(selectedCheckoutEmployee);
                return imgUrl ? (
                  <CachedImage src={imgUrl} alt="emp" style={{ borderRadius: "30px", height: "4vh", width: "4vh", alignSelf: "center" }} fallbackStyle={{ borderRadius: "30px", height: "4vh", width: "4vh", background: "#ddd" }} />
                ) : (
                  <img src={photo} alt="" style={{ borderRadius: "30px", height: "4vh", alignSelf: "center" }} />
                );
              })()}
              <p style={{ color: "white" }}>{selectedCheckoutEmployee?.staff_name || selectedCheckoutEmployee?.name || userInfo?.userName}</p>
              <div style={{ placeSelf: "end" }}>
                <IconButton
                  onClick={() => setShowSecondCheckOutPopup(false)}
                >
                  <HighlightOffOutlinedIcon
                    sx={{
                      color: "white",
                      fontSize: "30px",
                      fontWeight: "400",
                    }}
                  />
                </IconButton>
              </div>
            </div>
            <div style={{ paddingBottom: "11px" }}>
              <div style={{ paddingInline: "10px" }}>
                <p style={{ justifySelf: "start", margin: "17px 7px 3px 3px" }}>Password</p>
                <input
                  // type="password"
                  // placeholder="Enter Password"
                  style={{
                    backgroundColor: "#ede9e9",
                    width: "100%",
                    padding: "8px",
                    marginTop: "10px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  onChange={(e) => setPassword(e.target.value)} // Use a state variable for the password
                />
              </div>
              <div style={{ display: "flex", gap: "10px", justifyContent: "center", paddingTop: "10px" }}>
                <button className="btn btn-success" style={{ fontWeight: "bold", color: "black", backgroundColor: "white", width: "78px", border: "solid 1px black" }} onClick={() => {
                  // perform check-in logic here
                  setShowSecondCheckOutPopup(false);
                  setShowCheckOutPopup(true);
                }}>
                  Cancel
                </button>
                <button className="btn btn-secondary" style={{ color: "white", backgroundColor: "red", width: "78px" }} onClick={() => VerifyCheckOutPass(password)}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showFinalCheckOutPopup && (
        <div className="popup-overlay">
          <div className="popup-box" style={{ width: "387px", borderRadius: "10px", overflow: "hidden" }}>
            {/* Top bar with user name and image */}
            <div style={{ backgroundColor: "#14008C", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px", color: "white" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {(() => {
                  const imgUrl = resolveEmpImage(selectedCheckoutEmployee);
                  return imgUrl ? (
                    <CachedImage src={imgUrl} alt="emp" style={{ borderRadius: "50%", height: "35px", width: "35px" }} fallbackStyle={{ borderRadius: "50%", height: "35px", width: "35px", background: "#ddd" }} />
                  ) : (
                    <ColoredAvatar emp={selectedCheckoutEmployee} size={35} />
                  );
                })()}
                <span style={{ fontWeight: "bold" }}>{selectedCheckoutEmployee?.staff_name || selectedCheckoutEmployee?.name || userInfo?.userName}</span>
              </div>
              <IconButton onClick={() => setShowFinalCheckOutPopup(false)} style={{ color: "white" }}>
                <HighlightOffOutlinedIcon />
              </IconButton>
            </div>
            {/* Content */}
            <div style={{ padding: "15px", backgroundColor: "#fff" }}>
              <h4 style={{ margin: "1px 0px 15px 0px", justifySelf: "start", fontWeight: "400" }}>Denomination</h4>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", paddingInline: "9px", borderRadius: "3px", backgroundColor: "rgb(163 160 160)" }}>
                <span>Total</span>
                <span >{checkOutPassDetail?.data?.cashCardSummary?.amountTotal || "0.00"}</span>
              </div>
              {/* Payment modes */}

              {(() => {
                const filteredData = checkOutPassDetail?.data?.cashCardSummary?.data?.filter(r => !showUpArrow || r.type === "cash");

                if (!filteredData || filteredData.length === 0) {
                  return <div style={{ padding: "10px", color: "#888", textAlign: "center" }}>No Record Found</div>;
                }

                return filteredData.map((r, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      margin: "7px 0",
                      paddingLeft: "7px",
                      border: "solid 1px #bbb9b9",
                      backgroundColor: "#e1dfdf",
                      color: "black",
                      borderRadius: "5px",
                      padding: r.type !== "cash" || shiftStatus?.isDenomination === false ? "5px" : "0 0 0 6px"
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <span>{r.name}</span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <span>{Number(r.totalAmount).toFixed(2)}</span>
                      {r.type === "cash" && shiftStatus?.isDenomination === true && (
                        <span
                          onClick={toggleUpArrow}
                          style={{ padding: "6px 4px", backgroundColor: "#f9c9c9", cursor: "pointer" }}
                        >
                          {showUpArrow ? (
                            <ArrowUpwardIcon style={{ color: "red", fontSize: "18px" }} />
                          ) : (
                            <ArrowDownwardIcon style={{ color: "red", fontSize: "18px" }} />
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                ));


              })()}
              {shiftStatus?.isDenomination === true && (
                <textarea
                  placeholder="description for denomination.."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  style={{
                    width: "100%",
                    minHeight: "60px",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    resize: "vertical",
                    backgroundColor: "rgb(245 241 241)"
                  }}
                />
              )}

              {!showUpArrow && (
                <>
                  {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0" ,padding:"7px", border:"solid 1px #bbb9b9",backgroundColor:"#e1dfdf", borderRadius:"5px"}}>
          <img src={card} alt="" style={{ width: "40px", height: "25px" }} />
          <span>552.00</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0",padding:"7px", border:"solid 1px #bbb9b9",backgroundColor:"#e1dfdf", borderRadius:"5px" }}>
          <img src={UPI} alt="" style={{ width: "40px", height: "25px" }} />
          <span>8,545.00</span>
        </div> */}

                  <h4 style={{ margin: "21px 0px 7px 0px", justifySelf: "start", fontWeight: "400" }}>Order Total</h4>
                  {(() => {
                    const posOrders = checkOutPassDetail?.data?.posOrderSummary;

                    if (!posOrders || posOrders.length === 0) {
                      return <div style={{ padding: "10px", color: "#888", textAlign: "center" }}>No Record Found</div>;
                    }

                    return posOrders.map((r, i) => {
                      // Here you can add your orderType styles and render as you need
                      let backgroundColor = "";
                      let color = "";
                      let padding = "";

                      if (r.ordType === "DELIVERY") {
                        backgroundColor = "rgb(194 199 253)";
                        color = "rgb(13 38 113)";
                        padding = "4px 21px 4px 12px";
                      } else if (r.ordType === "DINEIN") {
                        backgroundColor = "#f5cdcd";
                        color = "#c50909";
                        padding = "4px 30px 4px 12px";
                      } else if (r.ordType === "TAKEAWAY") {
                        backgroundColor = "rgb(200 231 204)";
                        color = "rgb(47 155 61)";
                        padding = "4px 3px 4px 8px";
                      }

                      return (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            color,
                            paddingInline: "0 10px",
                            border: "solid 1px #bbb9b9",
                            backgroundColor: " rgb(225, 223, 223)",
                            borderRadius: "5px",
                            margin: "9px 0",
                          }}
                        >
                          <span style={{ borderRadius: "4px 0 0 4px", padding, backgroundColor, color, border: "solid 1px #cfc9c9" }}>
                            {r.ordType}
                          </span>
                          <span style={{ padding: "4px", color: "black" }}>{r.amtTotal}</span>
                        </div>
                      );
                    });
                  })()}

                </>)}

              {showUpArrow && shiftStatus?.isDenomination === true && (
                <div>
                  {entries.map((entry, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px",
                        margin: "9px 0",
                        border: "1px solid #bbb9b9",
                        borderRadius: "5px",
                        backgroundColor: "#e1dfdf",
                      }}
                    >
                      <input
                        type="number"
                        placeholder="currency"
                        value={entry.currency}
                        onChange={(e) => handleChange(index, "currency", e.target.value)}
                        style={{
                          padding: "6px",
                          width: "35%",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                        }}
                      />
                      <input
                        type="number"
                        placeholder="Count"
                        value={entry.count}
                        onChange={(e) => handleChange(index, "count", e.target.value)}
                        style={{
                          padding: "6px",
                          width: "35%",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                        }}
                      />
                      <button
                        onClick={() => deleteEntry(index)}
                        style={{
                          marginLeft: "8px",
                          backgroundColor: "#ff4d4d",
                          border: "none",
                          color: "white",
                          padding: "5px 8px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >

                        X
                      </button>
                    </div>
                  ))}
                  <div style={{ textAlign: "center" }}>
                    <button
                      onClick={addEntry}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: "#14008C",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    >
                      + Row
                    </button>
                  </div>
                </div>)}

              {/* Submit Button */}
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                {!showUpArrow && (
                  <button className="btn btn-primary" style={{ backgroundColor: "#14008C", width: "50%", color: "white", fontWeight: "bold" }} onClick={handleSubmitheckout}>
                    Submit
                  </button>)}
                {showUpArrow && (
                  <button className="btn btn-primary" style={{ backgroundColor: "#14008C", width: "50%", color: "white", fontWeight: "bold" }} onClick={handleAddSubmit}>
                    ADD
                  </button>)}
              </div>
            </div>
            {/* advance shift report template */}
            <div style={{ 
              position: 'fixed', 
              top: '-10000px', 
              left: '-10000px',
              width: '100%',
              height: 'auto',
              overflow: 'hidden',
              opacity: 0,
              pointerEvents: 'none'
            }}>
              <div ref={printRef}>
                <ShiftReportTable />
              </div>
            </div>


             {/* shift report template */}
            <div style={{ 
              position: 'fixed', 
              top: '-10000px', 
              left: '-10000px',
              width: '100%',
              height: 'auto',
              overflow: 'hidden',
              opacity: 0,
              pointerEvents: 'none'
            }}>
              <div ref={paymentsPrint}>
                <PosShiftReportPrint
                  branch={userBranchIdWS}
                  shift={shiftStatus?._id}
                  checkinSummary={checkinSummmary}
                  showDetails={true}
                />
              </div>
            </div>


          </div>
        </div>



      )}
      
      {/* Print Preview Dialog - Outside all popups */}
      {showPrintPreview && (
        <Dialog 
          open={showPrintPreview} 
          maxWidth="xl" 
          fullWidth
          onClose={(event, reason) => {
            // Prevent closing on backdrop click or escape key
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
              return;
            }
          }}
        >
          <DialogTitle>Shift Report - Print Preview</DialogTitle>
          <DialogContent style={{ minHeight: '400px', padding: '20px' }}>
            {(() => {
              // Get shift report type with fallback
              const reportType = selectedShiftReportType;
              console.log('Print Preview - Shift Report Type:', reportType);
              console.log('Branch:', userBranchpk, 'Shift:', userShiftCode);
              
              if (reportType === "Shift Report") {
                return <PosShiftReportPrint branch={userBranchpk} shift={userShiftCode} />;
              } else if (reportType === "Advanced Shift Report") {
                return (
                  <div>
                    <ShiftReportTable />
                  </div>
                );
              } else if (reportType === "Shift Summary Report") {
                return (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <h3>Shift Summary Report</h3>
                    <p>This report type is not yet implemented</p>
                  </div>
                );
              } else {
                return (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <h3>Unknown Report Type</h3>
                    <p>Report Type: {reportType}</p>
                  </div>
                );
              }
            })()}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              setShowPrintPreview(false);
              // Navigate to dashboard home after closing print preview
              dispatch(switch_to_billing_screen({ billingBoolean: false }));
              navigateTo('/userdashboard/dashboardhome');
            }}>Close</Button>
            <Button
              onClick={() => {
                window.print();
                setShowPrintPreview(false);
                // Navigate to dashboard home after printing
                dispatch(switch_to_billing_screen({ billingBoolean: false }));
                navigateTo('/userdashboard/dashboardhome');
              }}
              color="primary"
              variant="contained"
            >
              Print
            </Button>
          </DialogActions>
        </Dialog>
      )}
      
      {/* Receipt Print Dialog - Auto-triggers print for Advanced Shift Report */}
      {showReceiptPrintDialog && (
        <Dialog 
          open={showReceiptPrintDialog} 
          maxWidth="md" 
          fullWidth
          onClose={(event, reason) => {
            // Prevent closing on backdrop click or escape key
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
              return;
            }
          }}
        >
          <DialogTitle>Preparing Shift Report...</DialogTitle>
          <DialogContent style={{ minHeight: '300px', padding: '20px' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <p style={{ fontSize: '16px', color: '#666' }}>
                Loading shift data and generating report...
              </p>
              <p style={{ fontSize: '14px', color: '#999', marginTop: '10px' }}>
                Print dialog will open automatically in a few seconds
              </p>
            </div>
            {/* Hidden ShiftReportTable to trigger data fetching */}
            <div style={{ display: 'none' }}>
              <ShiftReportTable />
            </div>
            {/* Visible receipt print content - compact Bill Type view */}
            <div ref={receiptPrintRef} style={{ maxHeight: '400px', overflow: 'auto' }}>
              <AdvanceShiftReportPrintComponent selectedButton="BILL TYPE" />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              setShowReceiptPrintDialog(false);
              // Navigate to dashboard home
              dispatch(switch_to_billing_screen({ billingBoolean: false }));
              navigateTo('/userdashboard/dashboardhome');
            }}>Cancel</Button>
            <Button
              onClick={() => {
                handleReceiptPrint();
              }}
              color="primary"
              variant="contained"
            >
              Print Now
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Ecommerce Notification Panel */}
      <EcommerceNotificationPanel
        open={ecommerceNotificationOpen}
        onClose={() => setEcommerceNotificationOpen(false)}
        onOrderConfirmed={(data) => {
          // Refresh pending count after order confirmation
          axios.get('/api/ecommerce-store/me/pending-orders')
            .then(res => {
              if (res?.data?.success) {
                setEcommercePendingCount((res.data.data || []).length);
              }
            })
            .catch(() => {});
        }}
      />
    </>
  );
}

export default function Dashboard() {
  return <DashboardContent />;
}
